var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "container materialMasterAdd" },
        [
          _c(
            "div",
            { staticClass: "searchBox_bottom" },
            [
              _vm.createParams.isSave || _vm.roterType == "copy"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.isDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.save(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                  )
                : _vm._e(),
              _vm.createParams.isSubmit || !this.id || _vm.roterType == "copy"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.isDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.save(2)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  )
                : _vm._e(),
              _vm.isExamine
                ? _c(
                    "el-button",
                    {
                      key: "showApproval",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showApproval = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("material.showApproval")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showContrast = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("material.showContrast")))]
              ),
              _vm.isShowFile && _vm.id
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: { margin: "0 10px" },
                      attrs: {
                        action: "upload",
                        "http-request": _vm.uploadConfirm,
                        "show-file-list": false,
                        multiple: "",
                        name: "file",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "mini",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v(_vm._s(_vm.$t("common.upload")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.fileList.length > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showFileTable = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("material.seeattachment")))]
                  )
                : _vm._e(),
              _c(
                "el-link",
                {
                  staticClass: "MaterialTemplate",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadTemplate(
                        "/templates/download/物料字段详解v4.pdf",
                        "物料字段详解v4.pdf"
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("material.MaterialTemplate")))]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "createParams",
              attrs: {
                model: _vm.createParams,
                rules: _vm.rules,
                "label-position": _vm.labelPosition,
                disabled: _vm.disaForm,
              },
            },
            [
              _c(
                "el-tabs",
                { attrs: { type: "border-card" } },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: _vm.$t("material.createParams") } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("common.createBy"),
                                    prop: "createUserName",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "", disabled: "" },
                                    model: {
                                      value: _vm.createParams.createUserName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "createUserName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "createParams.createUserName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("common.createDate"),
                                    prop: "createDate",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "", disabled: "" },
                                    model: {
                                      value: _vm.createParams.createDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "createDate",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "createParams.createDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.edition"),
                                    prop: "edition",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "", disabled: "" },
                                    model: {
                                      value: _vm.createParams.edition,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "edition",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "createParams.edition",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.conductStatus"),
                                    prop: "conductStatusI18n",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "", disabled: "" },
                                    model: {
                                      value: _vm.createParams.conductStatusI18n,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "conductStatusI18n",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "createParams.conductStatusI18n",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.eightBitCode"),
                                    prop: "eightBitCode",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  (_vm.$route.query.type !== "copy" &&
                                    _vm.isPop) ||
                                  _vm.isEightBitCode
                                    ? _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          onkeyup:
                                            "this.value=this.value.replace(/[^\\w]/g,'');",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.createParams.eightBitCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "eightBitCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "createParams.eightBitCode",
                                        },
                                      })
                                    : _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.createParams.eightBitCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "eightBitCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "createParams.eightBitCode",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "material.settlementUnitCode"
                                    ),
                                    prop: "settlementUnitCode",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        readonly: "",
                                        disabled:
                                          _vm.createParams.conductStatus ==
                                            "approved" ||
                                          _vm.disaSettlementUnitCode ||
                                          _vm.createParams
                                            .isUpdateSettlementUnit,
                                      },
                                      model: {
                                        value:
                                          _vm.createParams.settlementUnitCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "settlementUnitCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.settlementUnitCode",
                                      },
                                    },
                                    [
                                      !(
                                        _vm.createParams.conductStatus ==
                                          "approved" ||
                                        _vm.disaSettlementUnitCode ||
                                        _vm.createParams.conductStatus ==
                                          "mdm_maintenance" ||
                                        _vm.createParams.isUpdateSettlementUnit
                                      )
                                        ? _c("el-button", {
                                            attrs: {
                                              slot: "append",
                                              icon: "el-icon-search",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.showSettlementUnitDialog = true
                                              },
                                            },
                                            slot: "append",
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "material.settlementUnitName"
                                    ),
                                    prop: "settlementUnitName",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { disabled: "" },
                                    model: {
                                      value:
                                        _vm.createParams.settlementUnitName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "settlementUnitName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "createParams.settlementUnitName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.tmPlantName"),
                                    prop: "tmPlantName",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _vm.createParams.tmPlantName
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            content:
                                              _vm.createParams.tmPlantName,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                readonly: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.createParams.tmPlantName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "tmPlantName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.tmPlantName",
                                              },
                                            },
                                            [
                                              !(
                                                _vm.createParams
                                                  .conductStatus ==
                                                  "approved" ||
                                                _vm.createParams
                                                  .conductStatus ==
                                                  "mdm_maintenance" ||
                                                _vm.disaSettlementUnitCode ||
                                                _vm.createParams
                                                  .isUpdateSettlementUnit
                                              )
                                                ? _c("el-button", {
                                                    attrs: {
                                                      slot: "append",
                                                      icon: "el-icon-search",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.isShowPlan(
                                                          _vm.createParams
                                                            .conductStatus ==
                                                            "approved" ||
                                                            _vm.createParams
                                                              .conductStatus ==
                                                              "mdm_maintenance" ||
                                                            _vm.disaSettlementUnitCode ||
                                                            _vm.createParams
                                                              .isUpdateSettlementUnit
                                                        )
                                                      },
                                                    },
                                                    slot: "append",
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.createParams.tmPlantName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "tmPlantName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.tmPlantName",
                                          },
                                        },
                                        [
                                          !(
                                            _vm.createParams.conductStatus ==
                                              "approved" ||
                                            _vm.createParams.conductStatus ==
                                              "mdm_maintenance" ||
                                            _vm.disaSettlementUnitCode ||
                                            _vm.createParams
                                              .isUpdateSettlementUnit
                                          )
                                            ? _c("el-button", {
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-search",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.isShowPlan(
                                                      _vm.createParams
                                                        .conductStatus ==
                                                        "approved" ||
                                                        _vm.createParams
                                                          .conductStatus ==
                                                          "mdm_maintenance" ||
                                                        _vm.disaSettlementUnitCode ||
                                                        _vm.createParams
                                                          .isUpdateSettlementUnit
                                                    )
                                                  },
                                                },
                                                slot: "append",
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "工厂编码",
                                    prop: "plantCodeView",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.createParams.plantCodeView,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "plantCodeView",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "createParams.plantCodeView",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.tmMaterial"),
                                    prop: "status",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      table: "TM_MATERIAL",
                                      field: "STATUS",
                                      disabled: _vm.isSup || _vm.disaHead,
                                    },
                                    model: {
                                      value: _vm.createParams.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "createParams.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.showGriDialogFun"),
                                    prop: "fiveBitCode",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        readonly: "",
                                        disabled:
                                          _vm.isSup ||
                                          _vm.createParams.conductStatus ==
                                            "approved" ||
                                          _vm.disaHead ||
                                          _vm.createParams.conductStatus ==
                                            "mdm_maintenance" ||
                                          (_vm.createParams.conductStatus ==
                                            "return" &&
                                            _vm.createParams
                                              .isUpdateSettlementUnit),
                                      },
                                      model: {
                                        value: _vm.createParams.fiveBitCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "fiveBitCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "createParams.fiveBitCode",
                                      },
                                    },
                                    [
                                      !(
                                        _vm.isSup ||
                                        _vm.createParams.conductStatus ==
                                          "approved" ||
                                        _vm.disaHead ||
                                        _vm.createParams.conductStatus ==
                                          "mdm_maintenance" ||
                                        (_vm.createParams.conductStatus ==
                                          "return" &&
                                          _vm.createParams
                                            .isUpdateSettlementUnit)
                                      )
                                        ? _c("el-button", {
                                            attrs: {
                                              slot: "append",
                                              icon: "el-icon-search",
                                            },
                                            on: { click: _vm.showGriDialogFun },
                                            slot: "append",
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "是否NFSC审批",
                                    prop: "isLto",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      table: "TM_MATERIAL_RECORD",
                                      field: "IS_NOT",
                                      disabled:
                                        _vm.$route.query.type !== "copy" &&
                                        (_vm.disaHead ||
                                          (_vm.materialType ==
                                            "new_conventional_material" &&
                                            (!_vm.createParams.conductStatus ||
                                              _vm.createParams.conductStatus ===
                                                "mdm_newly_build"))),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.getLeaderList(),
                                          (_vm.createParams.approvedBy = null),
                                          (_vm.createParams.isPromotionalItem =
                                            _vm.createParams.isLto)
                                      },
                                    },
                                    model: {
                                      value: _vm.createParams.isLto,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.createParams, "isLto", $$v)
                                      },
                                      expression: "createParams.isLto",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "非常规物料标识",
                                        prop: "isConventionalMaterials",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          on: {
                                            change:
                                              _vm.isConventionalMaterialsChange,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .isConventionalMaterials,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isConventionalMaterials",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.isConventionalMaterials",
                                          },
                                        },
                                        _vm._l(
                                          _vm.isConventionalMaterialsList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.createParams.isConventionalMaterials == "Y"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("material.isGift"),
                                        prop: "isGift",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          table: "TM_MATERIAL_RECORD",
                                          field: "IS_NOT",
                                          disabled: _vm.disaHead,
                                        },
                                        model: {
                                          value: _vm.createParams.isGift,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "isGift",
                                              $$v
                                            )
                                          },
                                          expression: "createParams.isGift",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.selectApprovedBy"),
                                    prop: "approvedBy",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: _vm.disaHead },
                                      on: { change: _vm.selectApprovedBy },
                                      model: {
                                        value: _vm.createParams.approvedBy,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "approvedBy",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.approvedBy",
                                      },
                                    },
                                    _vm._l(
                                      _vm.leaderList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.userName,
                                            value: item.tmUserId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isShowParams &&
                          _vm.createParams.isConventionalMaterials == "Y"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "CQS是否审批",
                                        prop: "isCqsAudit",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: {
                                          width: "100%!important",
                                        },
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "IS_NOT",
                                        },
                                        on: { change: _vm.isCqsAuditChange },
                                        model: {
                                          value: _vm.createParams.isCqsAudit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "isCqsAudit",
                                              $$v
                                            )
                                          },
                                          expression: "createParams.isCqsAudit",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isShowParams &&
                          _vm.createParams.isConventionalMaterials == "Y"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "CQS审批人",
                                        prop: "cqsAuditor",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled:
                                              _vm.createParams.isCqsAudit !==
                                              "Y",
                                          },
                                          model: {
                                            value: _vm.createParams.cqsAuditor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "cqsAuditor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.cqsAuditor",
                                          },
                                        },
                                        _vm._l(
                                          _vm.cqsAuditorLists,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.userName,
                                                value: item.tmUserId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isShowParams &&
                          _vm.createParams.isConventionalMaterials == "Y"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Finance是否审批",
                                        prop: "isFinanceAudit",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: {
                                          width: "100%!important",
                                        },
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "IS_NOT",
                                        },
                                        on: {
                                          change: _vm.isFinanceAuditChange,
                                        },
                                        model: {
                                          value:
                                            _vm.createParams.isFinanceAudit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "isFinanceAudit",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "createParams.isFinanceAudit",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isShowParams &&
                          _vm.createParams.isConventionalMaterials == "Y"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Finance审批人",
                                        prop: "financeAuditor",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled:
                                              _vm.createParams
                                                .isFinanceAudit !== "Y",
                                          },
                                          on: { change: _vm.selectApprovedBy },
                                          model: {
                                            value:
                                              _vm.createParams.financeAuditor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "financeAuditor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.financeAuditor",
                                          },
                                        },
                                        _vm._l(
                                          _vm.financeAuditorLists,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.tmUserId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.emplFlag == "M" &&
                          _vm.createParams.isUpdateSettlementUnit
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "是否新增DC",
                                        prop: "isNewDc",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: !_vm.id },
                                          model: {
                                            value: _vm.createParams.isNewDc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isNewDc",
                                                $$v
                                              )
                                            },
                                            expression: "createParams.isNewDc",
                                          },
                                        },
                                        _vm._l(
                                          _vm.isNewDcList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                                disabled: item.disabled,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-form-item__error fixed-tip",
                                        },
                                        [
                                          _vm._v(
                                            "(直送DC物料仅拓展BU且运费不变，请选是)"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "是否促销品",
                                    prop: "isPromotionalItem",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      table: "TM_MATERIAL_RECORD",
                                      field: "IS_PROMOTIONALITEM",
                                      disabled:
                                        _vm.$route.query.type !== "copy" &&
                                        (_vm.disaHead ||
                                          (_vm.materialType ==
                                            "new_conventional_material" &&
                                            (!_vm.createParams.conductStatus ||
                                              _vm.createParams.conductStatus ===
                                                "mdm_newly_build"))),
                                    },
                                    model: {
                                      value: _vm.createParams.isPromotionalItem,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "isPromotionalItem",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "createParams.isPromotionalItem",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "供应商侧物料编码",
                                    prop: "supplierMaterialCode",
                                    "label-width": "110px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.disaHead,
                                      maxlength: "50",
                                    },
                                    model: {
                                      value:
                                        _vm.createParams.supplierMaterialCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createParams,
                                          "supplierMaterialCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "createParams.supplierMaterialCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.emplFlag !== "S"
                            ? _c(
                                "el-col",
                                { attrs: { span: 18 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "画稿",
                                        prop: "drawings",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          maxlength: "50",
                                          "show-word-limit": "",
                                          disabled: _vm.disaHead,
                                        },
                                        model: {
                                          value: _vm.createParams.drawings,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "drawings",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "createParams.drawings",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.emplFlag !== "S"
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "主要材质",
                                        prop: "mainMaterial",
                                        "label-width": "110px",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { disabled: _vm.disaHead },
                                        model: {
                                          value: _vm.createParams.mainMaterial,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "mainMaterial",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "createParams.mainMaterial",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "table",
                        { staticStyle: { "padding-top": "15px" } },
                        [
                          _c("tr", { staticStyle: { height: "35px" } }, [
                            _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v(_vm._s(_vm.$t("material.nowVersion"))),
                            ]),
                            _vm.oldRecordExists
                              ? _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.LastVersion"))
                                  ),
                                ])
                              : _vm._e(),
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.$t("material.ComparisonMaterial"))
                              ),
                            ]),
                          ]),
                          _c("tr", [_c("th", { staticClass: "card-title" })]),
                          _c("tr", [
                            _c("td", { staticStyle: { width: "230px" } }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.chineseNameOfProduct"))
                              ),
                            ]),
                            _c(
                              "td",
                              { staticStyle: { width: "230px" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "eightBitCodeName" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          content:
                                            _vm.createParams.eightBitCodeName,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "100",
                                            disabled: _vm.isFpa,
                                            clearable: "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.delTrim(
                                                _vm.createParams
                                                  .eightBitCodeName,
                                                "eightBitCodeName"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.eightBitCodeName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "eightBitCodeName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.eightBitCodeName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    staticStyle: { width: "230px" },
                                    style: {
                                      color:
                                        _vm.createParams.eightBitCodeName ==
                                        _vm.oldParams.eightBitCodeName
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.eightBitCodeName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                staticStyle: { width: "230px" },
                                style: {
                                  color:
                                    _vm.createParams.eightBitCodeName ==
                                    _vm.contrastParams.eightBitCodeName
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams.eightBitCodeName
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.englishNameOfProduct"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "rawProductEName" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          content:
                                            _vm.createParams.rawProductEName,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "100",
                                            clearable: "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.delTrim(
                                                _vm.createParams
                                                  .rawProductEName,
                                                "rawProductEName"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.rawProductEName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "rawProductEName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.rawProductEName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.rawProductEName ==
                                        _vm.oldParams.rawProductEName
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.rawProductEName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.rawProductEName ==
                                    _vm.contrastParams.rawProductEName
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.rawProductEName) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.englishAbbreviationOfProduct"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "rawProductEAbbreviation",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "28",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .rawProductEAbbreviation,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "rawProductEAbbreviation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.rawProductEAbbreviation",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .rawProductEAbbreviation ==
                                            _vm.oldParams
                                              .rawProductEAbbreviation
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .rawProductEAbbreviation
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .rawProductEAbbreviation ==
                                        _vm.contrastParams
                                          .rawProductEAbbreviation
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .rawProductEAbbreviation
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isPop
                            ? [
                                !_vm.isSup
                                  ? _c("tr", [
                                      _c("td", [
                                        _c("span", [_vm._v("*")]),
                                        _vm._v(
                                          _vm._s(_vm.$t("material.sumsSort"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "sumsSort" } },
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "SUMS_SORT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams.sumsSort,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "sumsSort",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.sumsSort",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "SUMS_SORT",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value: _vm.oldParams.sumsSort,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.oldParams,
                                                      "sumsSort",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "oldParams.sumsSort",
                                                },
                                              }),
                                              _vm.createParams.sumsSort !=
                                                _vm.oldParams.sumsSort &&
                                              _vm.oldParams.sumsSort
                                                ? _c("span", [_vm._v("!")])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SUMS_SORT",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.contrastParams.sumsSort,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contrastParams,
                                                  "sumsSort",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contrastParams.sumsSort",
                                            },
                                          }),
                                          _vm.createParams.sumsSort !=
                                            _vm.contrastParams.sumsSort &&
                                          _vm.contrastParams.sumsSort
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isSup
                                  ? _c("tr", [
                                      _c("td", [
                                        _c("span", [_vm._v("*")]),
                                        _vm._v(
                                          _vm._s(_vm.$t("material.specifiUom"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "specifiUom" } },
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "SPECIFI_UOM",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams.specifiUom,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "specifiUom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.specifiUom",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "SPECIFI_UOM",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.oldParams.specifiUom,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.oldParams,
                                                      "specifiUom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "oldParams.specifiUom",
                                                },
                                              }),
                                              _vm.createParams.specifiUom !=
                                                _vm.oldParams.specifiUom &&
                                              _vm.oldParams.specifiUom
                                                ? _c("span", [_vm._v("!")])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SPECIFI_UOM",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.contrastParams.specifiUom,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contrastParams,
                                                  "specifiUom",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contrastParams.specifiUom",
                                            },
                                          }),
                                          _vm.createParams.specifiUom !=
                                            _vm.contrastParams.specifiUom &&
                                          _vm.contrastParams.specifiUom
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isSup
                                  ? _c("tr", [
                                      _c("td", [
                                        _c("span", [_vm._v("*")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "material.projectOrCategoryLeader"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "projectOrCategoryLeader",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "100",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .projectOrCategoryLeader,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "projectOrCategoryLeader",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.projectOrCategoryLeader",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams
                                                    .projectOrCategoryLeader ==
                                                  _vm.oldParams
                                                    .projectOrCategoryLeader
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.oldParams
                                                      .projectOrCategoryLeader
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .projectOrCategoryLeader ==
                                              _vm.contrastParams
                                                .projectOrCategoryLeader
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.contrastParams
                                                  .projectOrCategoryLeader
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "tr",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSup,
                                        expression: "!isSup",
                                      },
                                    ],
                                  },
                                  [
                                    _c("td", [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        _vm._s(_vm.$t("material.department"))
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "department" } },
                                          [
                                            _c("ic-select", {
                                              attrs: {
                                                clearable: "",
                                                table: "TM_MATERIAL_RECORD",
                                                field: "DEPARTMENT",
                                              },
                                              model: {
                                                value:
                                                  _vm.createParams.department,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "department",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.department",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.oldRecordExists
                                      ? _c(
                                          "td",
                                          [
                                            _c("ic-select", {
                                              attrs: {
                                                clearable: "",
                                                table: "TM_MATERIAL_RECORD",
                                                field: "DEPARTMENT",
                                                disabled: "",
                                              },
                                              model: {
                                                value: _vm.oldParams.department,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.oldParams,
                                                    "department",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "oldParams.department",
                                              },
                                            }),
                                            _vm.createParams.department !=
                                              _vm.oldParams.department &&
                                            _vm.oldParams.department
                                              ? _c("span", [_vm._v("!")])
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "DEPARTMENT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.contrastParams.department,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.contrastParams,
                                                "department",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "contrastParams.department",
                                          },
                                        }),
                                        _vm.createParams.department !=
                                          _vm.contrastParams.department &&
                                        _vm.contrastParams.department
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "tr",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSup,
                                        expression: "!isSup",
                                      },
                                    ],
                                  },
                                  [
                                    _c("td", [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        _vm._s(_vm.$t("material.formarkets"))
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "formarkets" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                },
                                                model: {
                                                  value: _vm.formarkets,
                                                  callback: function ($$v) {
                                                    _vm.formarkets = $$v
                                                  },
                                                  expression: "formarkets",
                                                },
                                              },
                                              _vm._l(
                                                _vm.formarketsList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.chineseValue,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.oldRecordExists
                                      ? _c(
                                          "td",
                                          [
                                            _c("ic-select", {
                                              staticClass: "multiple_sel",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table: "TM_MATERIAL_RECORD",
                                                field: "FORMARKETS",
                                                multiple: "",
                                                disabled: "",
                                              },
                                              model: {
                                                value: _vm.oldFormarkets,
                                                callback: function ($$v) {
                                                  _vm.oldFormarkets = $$v
                                                },
                                                expression: "oldFormarkets",
                                              },
                                            }),
                                            _vm.oldFormarketsFlag &&
                                            _vm.oldFormarkets.length > 0
                                              ? _c("span", [_vm._v("!")])
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          staticClass: "multiple_sel",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "FORMARKETS",
                                            multiple: "",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.contrastFormarkets,
                                            callback: function ($$v) {
                                              _vm.contrastFormarkets = $$v
                                            },
                                            expression: "contrastFormarkets",
                                          },
                                        }),
                                        _vm.contrastFormarketsFlag &&
                                        _vm.contrastFormarkets.length > 0
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "tr",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSup,
                                        expression: "!isSup",
                                      },
                                    ],
                                  },
                                  [
                                    _c("td", [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(_vm._s(_vm.$t("material.sizeMm"))),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "sizeMm" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                clearable: "",
                                                maxlength: "100",
                                              },
                                              model: {
                                                value: _vm.createParams.sizeMm,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "sizeMm",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.sizeMm",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.oldRecordExists
                                      ? _c(
                                          "td",
                                          {
                                            style: {
                                              color:
                                                _vm.createParams.sizeMm ==
                                                _vm.oldParams.sizeMm
                                                  ? ""
                                                  : "red",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.oldParams.sizeMm) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.sizeMm ==
                                            _vm.contrastParams.sizeMm
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.contrastParams.sizeMm) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "tr",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSup,
                                        expression: "!isSup",
                                      },
                                    ],
                                  },
                                  [
                                    _c("td", [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        _vm._s(_vm.$t("material.forStoreTier"))
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "forStoreTier" } },
                                          [
                                            _c("el-input", {
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.createParams.forStoreTier,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "forStoreTier",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.forStoreTier",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.oldRecordExists
                                      ? _c(
                                          "td",
                                          {
                                            style: {
                                              color:
                                                _vm.createParams.forStoreTier ==
                                                _vm.oldParams.forStoreTier
                                                  ? ""
                                                  : "red",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.oldParams.forStoreTier
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.forStoreTier ==
                                            _vm.contrastParams.forStoreTier
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.contrastParams.forStoreTier
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "tr",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isSup,
                                        expression: "!isSup",
                                      },
                                    ],
                                  },
                                  [
                                    _c("td", [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "material.internalAndExternalAreas"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "internalAndExternalAreas",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              attrs: {
                                                clearable: "",
                                                table: "TM_MATERIAL_RECORD",
                                                field:
                                                  "INTERNAL_AND_EXTERNAL_AREAS",
                                              },
                                              model: {
                                                value:
                                                  _vm.createParams
                                                    .internalAndExternalAreas,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "internalAndExternalAreas",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.internalAndExternalAreas",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.oldRecordExists
                                      ? _c(
                                          "td",
                                          [
                                            _c("ic-select", {
                                              attrs: {
                                                clearable: "",
                                                table: "TM_MATERIAL_RECORD",
                                                field:
                                                  "INTERNAL_AND_EXTERNAL_AREAS",
                                                disabled: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.oldParams
                                                    .internalAndExternalAreas,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.oldParams,
                                                    "internalAndExternalAreas",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "oldParams.internalAndExternalAreas",
                                              },
                                            }),
                                            _vm.createParams
                                              .internalAndExternalAreas !=
                                              _vm.oldParams
                                                .internalAndExternalAreas &&
                                            _vm.oldParams
                                              .internalAndExternalAreas
                                              ? _c("span", [_vm._v("!")])
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field:
                                              "INTERNAL_AND_EXTERNAL_AREAS",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.contrastParams
                                                .internalAndExternalAreas,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.contrastParams,
                                                "internalAndExternalAreas",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "contrastParams.internalAndExternalAreas",
                                          },
                                        }),
                                        _vm.createParams
                                          .internalAndExternalAreas !=
                                          _vm.contrastParams
                                            .internalAndExternalAreas &&
                                        _vm.contrastParams
                                          .internalAndExternalAreas
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.purchasingCategory")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "purchasingCategory" } },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              content:
                                                _vm.createParams
                                                  .purchasingCategory,
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                clearable: "",
                                                disabled: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.createParams
                                                    .purchasingCategory,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.createParams,
                                                    "purchasingCategory",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "createParams.purchasingCategory",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .purchasingCategory ==
                                            _vm.oldParams.purchasingCategory
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.purchasingCategory
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.purchasingCategory ==
                                        _vm.contrastParams.purchasingCategory
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.purchasingCategory
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.settlementClassification"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "settlementClassification",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "SETTLEMENT_CLASSIFICATION",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .settlementClassification,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "settlementClassification",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.settlementClassification",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "SETTLEMENT_CLASSIFICATION",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .settlementClassification,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "settlementClassification",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.settlementClassification",
                                          },
                                        }),
                                        _vm.createParams
                                          .settlementClassification !=
                                          _vm.oldParams
                                            .settlementClassification &&
                                        _vm.oldParams.settlementClassification
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "SETTLEMENT_CLASSIFICATION",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .settlementClassification,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "settlementClassification",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.settlementClassification",
                                      },
                                    }),
                                    _vm.createParams.settlementClassification !=
                                      _vm.contrastParams
                                        .settlementClassification &&
                                    _vm.contrastParams.settlementClassification
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? [
                                !_vm.isSup
                                  ? _c(
                                      "tr",
                                      [
                                        _c("td", [
                                          _c("span", [_vm._v("*")]),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "material.purchasingManager"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "purchasingManager",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.createParams
                                                        .purchasingManager,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.createParams,
                                                        "purchasingManager",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "createParams.purchasingManager",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.oldRecordExists
                                          ? _c(
                                              "td",
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.oldParams
                                                        .purchasingManager,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.oldParams,
                                                        "purchasingManager",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oldParams.purchasingManager",
                                                  },
                                                }),
                                                _vm.createParams
                                                  .purchasingManager !=
                                                  _vm.oldParams
                                                    .purchasingManager &&
                                                _vm.oldParams.purchasingManager
                                                  ? _c("span", [_vm._v("!")])
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.contrastParams
                                                .purchasingManager,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.contrastParams,
                                                "purchasingManager",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "contrastParams.purchasingManager",
                                          },
                                        }),
                                        _vm.createParams.purchasingManager !=
                                          _vm.contrastParams
                                            .purchasingManager &&
                                        _vm.contrastParams.purchasingManager
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.$t("material.rpEffectiveDate"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams
                                                  .rpEffectiveDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "rpEffectiveDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.rpEffectiveDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .rpEffectiveDate ==
                                              _vm.oldParams.rpEffectiveDate
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.oldParams.rpEffectiveDate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.rpEffectiveDate ==
                                          _vm.contrastParams.rpEffectiveDate
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams.rpEffectiveDate
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm.isFieldRequired("useArea")
                                      ? _c("span", [_vm._v("*")])
                                      : _vm._e(),
                                    _vm._v(_vm._s(_vm.$t("material.useArea"))),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop: "useArea",
                                            rules: _vm.isFieldRequired(
                                              "useArea"
                                            )
                                              ? [_vm.rules.requiredRules]
                                              : [],
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "USE_AREA",
                                            },
                                            model: {
                                              value: _vm.createParams.useArea,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "useArea",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.useArea",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.useArea ==
                                              _vm.oldParams.useArea
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "USE_AREA",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.oldParams.useArea,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.oldParams,
                                                  "useArea",
                                                  $$v
                                                )
                                              },
                                              expression: "oldParams.useArea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.useArea ==
                                          _vm.contrastParams.useArea
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "USE_AREA",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.contrastParams.useArea,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.contrastParams,
                                              "useArea",
                                              $$v
                                            )
                                          },
                                          expression: "contrastParams.useArea",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.$t("material.marketTime"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value:
                                                _vm.createParams.marketTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "marketTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.marketTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.marketTime ==
                                              _vm.oldParams.marketTime
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.oldParams.marketTime) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.marketTime ==
                                          _vm.contrastParams.marketTime
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams.marketTime
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.emplFlag !== "S"
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm.isFieldRequired("stopSaleDate")
                                          ? _c("span", [_vm._v("*")])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("material.StopSaleDate")
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "stopSaleDate" } },
                                            [
                                              _c("el-date-picker", {
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .stopSaleDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "stopSaleDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.stopSaleDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams
                                                    .stopSaleDate ==
                                                  _vm.oldParams.stopSaleDate
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.oldParams.stopSaleDate
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.stopSaleDate ==
                                              _vm.contrastParams.stopSaleDate
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.contrastParams.stopSaleDate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.taxClassificationCode"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "taxClassificationCode" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.createParams
                                            .taxClassificationCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "taxClassificationCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.taxClassificationCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .taxClassificationCode ==
                                        _vm.oldParams.taxClassificationCode
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldParams.taxClassificationCode
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.taxClassificationCode ==
                                    _vm.contrastParams.taxClassificationCode
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams.taxClassificationCode
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.canCtcSettle"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "canCtcSettle",
                                      rules: [_vm.rules.requiredRules],
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                      },
                                      on: { change: _vm.changeCanCtcSettle },
                                      model: {
                                        value: _vm.createParams.canCtcSettle,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "canCtcSettle",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.canCtcSettle",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.canCtcSettle,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "canCtcSettle",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.canCtcSettle",
                                      },
                                    }),
                                    _vm.createParams.canCtcSettle !=
                                      _vm.oldParams.canCtcSettle &&
                                    _vm.oldParams.canCtcSettle
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "IS_NOT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.canCtcSettle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "canCtcSettle",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.canCtcSettle",
                                  },
                                }),
                                _vm.createParams.canCtcSettle !=
                                  _vm.contrastParams.canCtcSettle &&
                                _vm.contrastParams.canCtcSettle
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm.createParams.canCtcSettle == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.isCtcImport"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "isCtcImport" } },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          model: {
                                            value: _vm.createParams.isCtcImport,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isCtcImport",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.isCtcImport",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.oldParams.isCtcImport,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "isCtcImport",
                                                $$v
                                              )
                                            },
                                            expression: "oldParams.isCtcImport",
                                          },
                                        }),
                                        _vm.createParams.isCtcImport !=
                                          _vm.oldParams.isCtcImport &&
                                        _vm.oldParams.isCtcImport
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.contrastParams.isCtcImport,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "isCtcImport",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.isCtcImport",
                                      },
                                    }),
                                    _vm.createParams.isCtcImport !=
                                      _vm.contrastParams.isCtcImport &&
                                    _vm.contrastParams.isCtcImport
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.canCtcSettle == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.isCtcDirectMining"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "isCtcDirectMining" } },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .isCtcDirectMining,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isCtcDirectMining",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.isCtcDirectMining",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.isCtcDirectMining,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "isCtcDirectMining",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.isCtcDirectMining",
                                          },
                                        }),
                                        _vm.createParams.isCtcDirectMining !=
                                          _vm.oldParams.isCtcDirectMining &&
                                        _vm.oldParams.isCtcDirectMining
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams.isCtcDirectMining,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "isCtcDirectMining",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.isCtcDirectMining",
                                      },
                                    }),
                                    _vm.createParams.isCtcDirectMining !=
                                      _vm.contrastParams.isCtcDirectMining &&
                                    _vm.contrastParams.isCtcDirectMining
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.$t("material.remarks"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "200",
                                            type: "textarea",
                                            clearable: "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.delTrim(
                                                _vm.createParams.remarks,
                                                "remarks"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.createParams.remarks,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "remarks",
                                                $$v
                                              )
                                            },
                                            expression: "createParams.remarks",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.remarks ==
                                            _vm.oldParams.remarks
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.remarks) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.remarks ==
                                        _vm.contrastParams.remarks
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.remarks) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("material.materialFactoryDetails")
                                )
                              ),
                            ]),
                          ]),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.importedOrNot"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "importedOrNot" } },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          on: {
                                            change: _vm.importedOrNotChange,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.importedOrNot,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "importedOrNot",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.importedOrNot",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.oldParams.importedOrNot,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "importedOrNot",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.importedOrNot",
                                          },
                                        }),
                                        _vm.createParams.importedOrNot !=
                                          _vm.oldParams.importedOrNot &&
                                        _vm.oldParams.importedOrNot
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.contrastParams.importedOrNot,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "importedOrNot",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.importedOrNot",
                                      },
                                    }),
                                    _vm.createParams.importedOrNot !=
                                      _vm.contrastParams.importedOrNot &&
                                    _vm.contrastParams.importedOrNot
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _vm.createParams.importedOrNot == "N" &&
                              !_vm.isPop
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                              _vm._v("GTIN"),
                            ]),
                            _c(
                              "td",
                              [
                                _vm.isPop
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            rules: _vm.rules.gtin2,
                                            onkeyup:
                                              "this.value=this.value.replace(/[^\\w]/g,'');",
                                          },
                                          model: {
                                            value: _vm.createParams.gtin,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "gtin",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.gtin",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "gtin",
                                          rules:
                                            _vm.createParams.importedOrNot ==
                                            "N"
                                              ? _vm.rules.gtin
                                              : _vm.rules.gtin2,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            onkeyup:
                                              "this.value=this.value.replace(/[^\\w]/g,'');",
                                          },
                                          model: {
                                            value: _vm.createParams.gtin,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "gtin",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.gtin",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.gtin ==
                                        _vm.oldParams.gtin
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.oldParams.gtin) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.gtin ==
                                    _vm.contrastParams.gtin
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.contrastParams.gtin) + " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.extendInventory"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "extendInventory" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                      },
                                      model: {
                                        value: _vm.createParams.extendInventory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "extendInventory",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.extendInventory",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.extendInventory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "extendInventory",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.extendInventory",
                                      },
                                    }),
                                    _vm.createParams.extendInventory !=
                                      _vm.oldParams.extendInventory &&
                                    _vm.oldParams.extendInventory
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "IS_NOT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.extendInventory,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "extendInventory",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "contrastParams.extendInventory",
                                  },
                                }),
                                _vm.createParams.extendInventory !=
                                  _vm.contrastParams.extendInventory &&
                                _vm.contrastParams.extendInventory
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.originCountry"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "originCountry" } },
                                  [
                                    _c("el-input", {
                                      attrs: { maxlength: "10", clearable: "" },
                                      model: {
                                        value: _vm.createParams.originCountry,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "originCountry",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.originCountry",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.originCountry ==
                                        _vm.oldParams.originCountry
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.originCountry) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.originCountry ==
                                    _vm.contrastParams.originCountry
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.originCountry) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.conversionCoefficient")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "conversionCoefficient",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "CONVERSION_COEFFICIENT",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .conversionCoefficient,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "conversionCoefficient",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.conversionCoefficient",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "CONVERSION_COEFFICIENT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .conversionCoefficient,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "conversionCoefficient",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.conversionCoefficient",
                                          },
                                        }),
                                        _vm.createParams
                                          .conversionCoefficient !=
                                          _vm.oldParams.conversionCoefficient &&
                                        _vm.oldParams.conversionCoefficient
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "CONVERSION_COEFFICIENT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .conversionCoefficient,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "conversionCoefficient",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.conversionCoefficient",
                                      },
                                    }),
                                    _vm.createParams.conversionCoefficient !=
                                      _vm.contrastParams
                                        .conversionCoefficient &&
                                    _vm.contrastParams.conversionCoefficient
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.$t("material.pickUpPeriod"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "pickUpPeriod" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        oninput:
                                          "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                      },
                                      model: {
                                        value: _vm.createParams.pickUpPeriod,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "pickUpPeriod",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "createParams.pickUpPeriod",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.pickUpPeriod ==
                                        _vm.oldParams.pickUpPeriod
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.pickUpPeriod) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.pickUpPeriod ==
                                    _vm.contrastParams.pickUpPeriod
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.pickUpPeriod) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr"),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [_vm._v("门店存货盘点频率")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "inventoryCountingFrequency",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_FIVE_BIT_CODE",
                                            field:
                                              "INVENTORY_COUNTING_FREQUENCY",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .inventoryCountingFrequency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "inventoryCountingFrequency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.inventoryCountingFrequency",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_FIVE_BIT_CODE",
                                            field:
                                              "INVENTORY_COUNTING_FREQUENCY",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .inventoryCountingFrequency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "inventoryCountingFrequency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.inventoryCountingFrequency",
                                          },
                                        }),
                                        _vm.createParams
                                          .inventoryCountingFrequency !=
                                          _vm.oldParams
                                            .inventoryCountingFrequency &&
                                        _vm.oldParams.inventoryCountingFrequency
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_FIVE_BIT_CODE",
                                        field: "INVENTORY_COUNTING_FREQUENCY",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .inventoryCountingFrequency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "inventoryCountingFrequency",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.inventoryCountingFrequency",
                                      },
                                    }),
                                    _vm.createParams
                                      .inventoryCountingFrequency !=
                                      _vm.contrastParams
                                        .inventoryCountingFrequency &&
                                    _vm.contrastParams
                                      .inventoryCountingFrequency
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.minimumOrders"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "minimumOrders" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        oninput:
                                          "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                      },
                                      on: { blur: _vm.minimumOrdersBlur },
                                      model: {
                                        value: _vm.createParams.minimumOrders,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "minimumOrders",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.minimumOrders",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.minimumOrders ==
                                        _vm.oldParams.minimumOrders
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.minimumOrders) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.minimumOrders ==
                                    _vm.contrastParams.minimumOrders
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.minimumOrders) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.minimumOrderUnit"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "minimumOrderUnit" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MINIMUM_ORDER_UNIT",
                                        disabled: _vm.isFpa,
                                      },
                                      model: {
                                        value:
                                          _vm.createParams.minimumOrderUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "minimumOrderUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.minimumOrderUnit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MINIMUM_ORDER_UNIT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.minimumOrderUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "minimumOrderUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "oldParams.minimumOrderUnit",
                                      },
                                    }),
                                    _vm.createParams.minimumOrderUnit !=
                                      _vm.oldParams.minimumOrderUnit &&
                                    _vm.oldParams.minimumOrderUnit
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "MINIMUM_ORDER_UNIT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.minimumOrderUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "minimumOrderUnit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "contrastParams.minimumOrderUnit",
                                  },
                                }),
                                _vm.createParams.minimumOrderUnit !=
                                  _vm.contrastParams.minimumOrderUnit &&
                                _vm.contrastParams.minimumOrderUnit
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.priceType"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "priceType" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "PRICE_TYPE",
                                        disabled: _vm.isFpa,
                                      },
                                      model: {
                                        value: _vm.createParams.priceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "priceType",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.priceType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "PRICE_TYPE",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.priceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "priceType",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.priceType",
                                      },
                                    }),
                                    _vm.createParams.priceType !=
                                      _vm.oldParams.priceType &&
                                    _vm.oldParams.priceType
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "PRICE_TYPE",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.priceType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "priceType",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.priceType",
                                  },
                                }),
                                _vm.createParams.priceType !=
                                  _vm.contrastParams.priceType &&
                                _vm.contrastParams.priceType
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm.createParams.priceType == 5
                            ? _c("tr", [
                                _c("td"),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "priceTypeText" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            maxlength: "50",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.priceTypeText,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "priceTypeText",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.priceTypeText",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.priceTypeText ==
                                            _vm.oldParams.priceTypeText
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.priceTypeText
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.priceTypeText ==
                                        _vm.contrastParams.priceTypeText
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.priceTypeText
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.disType"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "disType" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL",
                                        field: "DIS_TYPE",
                                        disabled: _vm.isFpa || _vm.isDisType,
                                      },
                                      on: { change: _vm.disTypeChange },
                                      model: {
                                        value: _vm.createParams.disType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "disType",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.disType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL",
                                        field: "DIS_TYPE",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.disType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "disType",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.disType",
                                      },
                                    }),
                                    _vm.createParams.disType !=
                                      _vm.oldParams.disType &&
                                    _vm.oldParams.disType
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL",
                                    field: "DIS_TYPE",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.disType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "disType",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.disType",
                                  },
                                }),
                                _vm.createParams.disType !=
                                  _vm.contrastParams.disType &&
                                _vm.contrastParams.disType
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _vm.createParams.disType == "DC_SUPPLIER_DC" ||
                              _vm.createParams.disType == "DC" ||
                              _vm.createParams.disType == "SUPPLIER_DC"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                              _vm._v("DCs"),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "dcs" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "multiple_sel",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          multiple: "",
                                          filterable: "",
                                          disabled: _vm.isFpa,
                                        },
                                        on: { change: _vm.verifyDcs },
                                        model: {
                                          value: _vm.dcs,
                                          callback: function ($$v) {
                                            _vm.dcs = $$v
                                          },
                                          expression: "dcs",
                                        },
                                      },
                                      _vm._l(
                                        _vm.dcList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.supplierName,
                                              value: item.tmSupplierId,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "multiple_sel",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          multiple: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.oldDcs,
                                          callback: function ($$v) {
                                            _vm.oldDcs = $$v
                                          },
                                          expression: "oldDcs",
                                        },
                                      },
                                      _vm._l(
                                        _vm.dcList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.supplierName,
                                              value: item.tmSupplierId,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _vm.oldDcsFlag && _vm.oldDcs.length > 0
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      multiple: "",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.contrastDcs,
                                      callback: function ($$v) {
                                        _vm.contrastDcs = $$v
                                      },
                                      expression: "contrastDcs",
                                    },
                                  },
                                  _vm._l(_vm.dcList, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.supplierName,
                                        value: item.tmSupplierId,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm.contrastDcsFlag &&
                                _vm.contrastDcs.length > 0
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("th", { staticClass: "card-title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.exFactoryPrice"))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.exFactoryUnitPriceIncludingTax"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "exFactoryUnitPrice" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            value: _vm._f("toFixed")(
                                              _vm.createParams
                                                .exFactoryUnitPrice,
                                              6
                                            ),
                                            type: "number",
                                            disabled: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .exFactoryUnitPrice ==
                                            _vm.oldParams.exFactoryUnitPrice
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.exFactoryUnitPrice
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.exFactoryUnitPrice ==
                                        _vm.contrastParams.exFactoryUnitPrice
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.exFactoryUnitPrice
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isPop ||
                                  _vm.isToys ||
                                  _vm.isConventionalMaterials
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.urchaseTaxRate"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "urchaseTaxRate",
                                          rules:
                                            _vm.isPop ||
                                            _vm.isToys ||
                                            _vm.isConventionalMaterials
                                              ? _vm.rules.urchaseTaxRate
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "",
                                              disabled: !(
                                                _vm.isPop ||
                                                _vm.isToys ||
                                                _vm.isConventionalMaterials ||
                                                _vm.createParams.isLto == "Y"
                                              ),
                                            },
                                            on: {
                                              change: _vm.computePurchaseTax,
                                            },
                                            model: {
                                              value:
                                                _vm.createParams.urchaseTaxRate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "urchaseTaxRate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.urchaseTaxRate",
                                            },
                                          },
                                          _vm._l(
                                            _vm.urchaseTaxRateList,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    _vm._f("inputChoiceI18n")(
                                                      item
                                                    ),
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "URCHASE_TAX_RATE",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.oldParams.urchaseTaxRate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "urchaseTaxRate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.urchaseTaxRate",
                                          },
                                        }),
                                        _vm.createParams.urchaseTaxRate !=
                                          _vm.oldParams.urchaseTaxRate &&
                                        _vm.oldParams.urchaseTaxRate
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "URCHASE_TAX_RATE",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams.urchaseTaxRate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "urchaseTaxRate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.urchaseTaxRate",
                                      },
                                    }),
                                    _vm.createParams.urchaseTaxRate !=
                                      _vm.contrastParams.urchaseTaxRate &&
                                    _vm.contrastParams.urchaseTaxRate
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isPop ||
                                  _vm.isToys ||
                                  _vm.isConventionalMaterials
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.exFactoryExcUnitPrice")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "exFactoryExcUnitPrice",
                                          rules:
                                            _vm.isPop ||
                                            _vm.isToys ||
                                            _vm.isConventionalMaterials
                                              ? _vm.rules.exFactoryExcUnitPrice
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            onkeyup:
                                              "this.value= this.value.match(/\\d+(\\.\\d{0,6})?/) ? this.value.match(/\\d+(\\.\\d{0,6})?/)[0] : ''",
                                            maxlength: "20",
                                            disabled:
                                              !(
                                                _vm.isPop ||
                                                _vm.isToys ||
                                                _vm.isConventionalMaterials
                                              ) ||
                                              _vm.createParams
                                                .isForeignCurrency == "Y",
                                          },
                                          on: { blur: _vm.computePurchaseTax },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .exFactoryExcUnitPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "exFactoryExcUnitPrice",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.exFactoryExcUnitPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .exFactoryExcUnitPrice ==
                                            _vm.oldParams.exFactoryExcUnitPrice
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .exFactoryExcUnitPrice
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .exFactoryExcUnitPrice ==
                                        _vm.contrastParams.exFactoryExcUnitPrice
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .exFactoryExcUnitPrice
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.purchaseTax"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "purchaseTax" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            value: _vm._f("toFixed")(
                                              _vm.createParams.purchaseTax,
                                              6
                                            ),
                                            disabled: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.purchaseTax ==
                                            _vm.oldParams.purchaseTax
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.purchaseTax) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.purchaseTax ==
                                        _vm.contrastParams.purchaseTax
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.purchaseTax) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.disType == "SUPPLIER"
                            ? _c("tr", [
                                _c("td", [
                                  (_vm.isPop ||
                                    _vm.isToys ||
                                    _vm.isConventionalMaterials) &&
                                  _vm.createParams.disType == "SUPPLIER"
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(_vm._s(_vm.$t("material.Freight"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "fpaFreight",
                                          rules:
                                            (_vm.isPop ||
                                              _vm.isToys ||
                                              _vm.isConventionalMaterials) &&
                                            _vm.createParams.disType ==
                                              "SUPPLIER"
                                              ? _vm.rules.fpaFreight
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: !(
                                              (_vm.isPop ||
                                                _vm.isToys ||
                                                _vm.isConventionalMaterials) &&
                                              _vm.createParams.disType ==
                                                "SUPPLIER"
                                            ),
                                          },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.fpaFreight =
                                                _vm.onBlur(
                                                  _vm.createParams.fpaFreight,
                                                  6
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.fpaFreight =
                                                _vm.onInput(
                                                  _vm.createParams.fpaFreight
                                                )
                                            },
                                          },
                                          model: {
                                            value: _vm.createParams.fpaFreight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "fpaFreight",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.fpaFreight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.fpaFreight ==
                                            _vm.oldParams.fpaFreight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.fpaFreight) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.fpaFreight ==
                                        _vm.contrastParams.fpaFreight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.fpaFreight) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isPop ||
                                  _vm.isToys ||
                                  _vm.isConventionalMaterials
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.priceEffectiveStartingTime"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "priceEffectiveStartingTime",
                                          rules:
                                            _vm.isPop ||
                                            _vm.isToys ||
                                            _vm.isConventionalMaterials
                                              ? _vm.rules
                                                  .priceEffectiveStartingTime
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            "value-format": "yyyy-MM-dd",
                                            disabled: !(
                                              _vm.isPop ||
                                              _vm.isToys ||
                                              _vm.isConventionalMaterials
                                            ),
                                            type: "date",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .priceEffectiveStartingTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "priceEffectiveStartingTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.priceEffectiveStartingTime",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .priceEffectiveStartingTime ==
                                            _vm.oldParams
                                              .priceEffectiveStartingTime
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .priceEffectiveStartingTime
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .priceEffectiveStartingTime ==
                                        _vm.contrastParams
                                          .priceEffectiveStartingTime
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .priceEffectiveStartingTime
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.futureFactoryRequiredPrice"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "futureFactoryRequiredPrice",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          on: {
                                            change:
                                              _vm.changeFutureFactoryRequiredPrice,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .futureFactoryRequiredPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "futureFactoryRequiredPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.futureFactoryRequiredPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .futureFactoryRequiredPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "futureFactoryRequiredPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.futureFactoryRequiredPrice",
                                          },
                                        }),
                                        _vm.createParams
                                          .futureFactoryRequiredPrice !=
                                          _vm.oldParams
                                            .futureFactoryRequiredPrice &&
                                        _vm.oldParams.futureFactoryRequiredPrice
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .futureFactoryRequiredPrice,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "futureFactoryRequiredPrice",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.futureFactoryRequiredPrice",
                                      },
                                    }),
                                    _vm.createParams
                                      .futureFactoryRequiredPrice !=
                                      _vm.contrastParams
                                        .futureFactoryRequiredPrice &&
                                    _vm.contrastParams
                                      .futureFactoryRequiredPrice
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup &&
                          _vm.createParams.futureFactoryRequiredPrice == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.futureExWorksNotTax")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { prop: "futureExWorksNotTax" },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            disabled: !(
                                              _vm.isPop ||
                                              _vm.isToys ||
                                              _vm.isConventionalMaterials
                                            ),
                                            value: _vm._f("toFixed")(
                                              _vm.createParams
                                                .futureExWorksNotTax,
                                              6
                                            ),
                                            onkeyup:
                                              "this.value= this.value.match(/\\d+(\\.\\d{0,6})?/) ? this.value.match(/\\d+(\\.\\d{0,6})?/)[0] : ''",
                                            maxlength: "20",
                                          },
                                          on: {
                                            clear:
                                              _vm.clearfuturePurchaseTaxAmount,
                                            blur: _vm.computeFutureExWorksWithTax,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .futureExWorksNotTax,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "futureExWorksNotTax",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.futureExWorksNotTax",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .futureExWorksNotTax ==
                                            _vm.oldParams.futureExWorksNotTax
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.futureExWorksNotTax
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.futureExWorksNotTax ==
                                        _vm.contrastParams.futureExWorksNotTax
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.futureExWorksNotTax
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup &&
                          _vm.createParams.futureFactoryRequiredPrice == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.futureExWorksWithTax")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            value: _vm._f("toFixed")(
                                              _vm.createParams
                                                .futureExWorksWithTax,
                                              6
                                            ),
                                            disabled: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .futureExWorksWithTax ==
                                            _vm.oldParams.futureExWorksWithTax
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.futureExWorksWithTax
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.futureExWorksWithTax ==
                                        _vm.contrastParams.futureExWorksWithTax
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .futureExWorksWithTax
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup &&
                          _vm.createParams.futureFactoryRequiredPrice == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.futurePriceEffectiveDate"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "futurePriceEffectiveDate",
                                        },
                                      },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            "value-format": "yyyy-MM-dd",
                                            disabled: !(
                                              _vm.isPop ||
                                              _vm.isToys ||
                                              _vm.isConventionalMaterials
                                            ),
                                            type: "date",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .futurePriceEffectiveDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "futurePriceEffectiveDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.futurePriceEffectiveDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .futurePriceEffectiveDate ==
                                            _vm.oldParams
                                              .futurePriceEffectiveDate
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .futurePriceEffectiveDate
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .futurePriceEffectiveDate ==
                                        _vm.contrastParams
                                          .futurePriceEffectiveDate
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .futurePriceEffectiveDate
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup &&
                          _vm.createParams.futureFactoryRequiredPrice == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.futurePurchaseTaxAmount")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "futurePurchaseTaxAmount",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            disabled: !(
                                              _vm.isPop ||
                                              _vm.isToys ||
                                              _vm.isConventionalMaterials
                                            ),
                                            value: _vm._f("toFixed")(
                                              _vm.createParams
                                                .futurePurchaseTaxAmount,
                                              6
                                            ),
                                            onkeyup:
                                              "this.value= this.value.match(/\\d+(\\.\\d{0,6})?/) ? this.value.match(/\\d+(\\.\\d{0,6})?/)[0] : ''",
                                            maxlength: "20",
                                          },
                                          on: {
                                            clear:
                                              _vm.clearfuturePurchaseTaxAmount,
                                            blur: _vm.computeFutureExWorksWithTax,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .futurePurchaseTaxAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "futurePurchaseTaxAmount",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.futurePurchaseTaxAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .futurePurchaseTaxAmount ==
                                            _vm.oldParams
                                              .futurePurchaseTaxAmount
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .futurePurchaseTaxAmount
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .futurePurchaseTaxAmount ==
                                        _vm.contrastParams
                                          .futurePurchaseTaxAmount
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .futurePurchaseTaxAmount
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup &&
                          _vm.createParams.futureFactoryRequiredPrice == "Y"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.previousExWorks"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "previousExWorks" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            value: _vm._f("toFixed")(
                                              _vm.createParams.previousExWorks,
                                              6
                                            ),
                                            onkeyup:
                                              "this.value= this.value.match(/\\d+(\\.\\d{0,6})?/) ? this.value.match(/\\d+(\\.\\d{0,6})?/)[0] : ''",
                                            maxlength: "20",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.previousExWorks,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "previousExWorks",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.previousExWorks",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.previousExWorks ==
                                            _vm.oldParams.previousExWorks
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.previousExWorks
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.previousExWorks ==
                                        _vm.contrastParams.previousExWorks
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.previousExWorks
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.ptoyServiceFeeApplicable"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: _vm.isSup,
                                          },
                                          on: { change: _vm.onChange },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .ptoyServiceFeeApplicable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "ptoyServiceFeeApplicable",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.ptoyServiceFeeApplicable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .ptoyServiceFeeApplicable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "ptoyServiceFeeApplicable",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.ptoyServiceFeeApplicable",
                                          },
                                        }),
                                        _vm.createParams
                                          .ptoyServiceFeeApplicable !=
                                          _vm.oldParams
                                            .ptoyServiceFeeApplicable &&
                                        _vm.oldParams.ptoyServiceFeeApplicable
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .ptoyServiceFeeApplicable,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "ptoyServiceFeeApplicable",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.ptoyServiceFeeApplicable",
                                      },
                                    }),
                                    _vm.createParams.ptoyServiceFeeApplicable !=
                                      _vm.contrastParams
                                        .ptoyServiceFeeApplicable &&
                                    _vm.contrastParams.ptoyServiceFeeApplicable
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.isSup &&
                                    _vm.createParams.ptoyServiceFeeApplicable ==
                                      "Y",
                                  expression:
                                    "!isSup && createParams.ptoyServiceFeeApplicable=='Y'",
                                },
                              ],
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.$t("material.serviceChargePerToy"))
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          oninput:
                                            "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                        },
                                        on: {
                                          blur: _vm.serviceChargePerToyBlur,
                                        },
                                        model: {
                                          value:
                                            _vm.createParams
                                              .serviceChargePerToy,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "serviceChargePerToy",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "createParams.serviceChargePerToy",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.oldRecordExists
                                ? _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams
                                            .serviceChargePerToy ==
                                          _vm.oldParams.serviceChargePerToy
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.oldParams.serviceChargePerToy
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "td",
                                {
                                  style: {
                                    color:
                                      _vm.createParams.serviceChargePerToy ==
                                      _vm.contrastParams.serviceChargePerToy
                                        ? ""
                                        : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.contrastParams.serviceChargePerToy
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.isSup &&
                                    _vm.createParams.ptoyServiceFeeApplicable ==
                                      "Y",
                                  expression:
                                    "!isSup && createParams.ptoyServiceFeeApplicable=='Y'",
                                },
                              ],
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.$t("material.toyServiceFeeTax"))
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          oninput:
                                            "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                        },
                                        model: {
                                          value:
                                            _vm.createParams.toyServiceFeeTax2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createParams,
                                              "toyServiceFeeTax2",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "createParams.toyServiceFeeTax2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.oldRecordExists
                                ? _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.toyServiceFeeTax ==
                                          _vm.oldParams.toyServiceFeeTax
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.oldParams.toyServiceFeeTax
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "td",
                                {
                                  style: {
                                    color:
                                      _vm.createParams.toyServiceFeeTax ==
                                      _vm.contrastParams.toyServiceFeeTax
                                        ? ""
                                        : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.contrastParams.toyServiceFeeTax
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.isSup &&
                                    _vm.createParams.ptoyServiceFeeApplicable ==
                                      "Y",
                                  expression:
                                    "!isSup && createParams.ptoyServiceFeeApplicable=='Y'",
                                },
                              ],
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("material.toyServiceFeeWithTax")
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm._f("toFixed")(
                                            _vm.createParams
                                              .toyServiceFeeWithTax,
                                            6
                                          ),
                                          clearable: "",
                                          disabled: "",
                                          oninput:
                                            "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.oldRecordExists
                                ? _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams
                                            .toyServiceFeeWithTax ==
                                          _vm.oldParams.toyServiceFeeWithTax
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.oldParams.toyServiceFeeWithTax
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "td",
                                {
                                  style: {
                                    color:
                                      _vm.createParams.toyServiceFeeWithTax ==
                                      _vm.contrastParams.toyServiceFeeWithTax
                                        ? ""
                                        : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.contrastParams.toyServiceFeeWithTax
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.isToyVendor
                            ? _c("tr", [
                                _c("td", [_vm._v("玩具服务商")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "TOY_VENDOR",
                                          },
                                          model: {
                                            value: _vm.createParams.toyVendor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "toyVendor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.toyVendor",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.outboundFreight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.createParams.outboundFreight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "outboundFreight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.outboundFreight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.outboundFreight ==
                                            _vm.oldParams.outboundFreight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.outboundFreight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.outboundFreight ==
                                        _vm.contrastParams.outboundFreight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.outboundFreight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup && _vm.isHappyMealSet
                            ? _c("tr", [
                                _c("th", { staticClass: "card-title" }, [
                                  _vm._v("外币金额"),
                                ]),
                              ])
                            : _vm._e(),
                          !_vm.isSup && _vm.isHappyMealSet
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v("是否需要外币结算"),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "isForeignCurrency",
                                          rules: _vm.isHappyMealSet
                                            ? _vm.rules.isForeignCurrency
                                            : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_FOREIGN_CURRENCY",
                                            disabled: !_vm.isHappyMealSet,
                                          },
                                          on: {
                                            change: _vm.isForeignCurrencyChange,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .isForeignCurrency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isForeignCurrency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.isForeignCurrency",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_FOREIGN_CURRENCY",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.isForeignCurrency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "isForeignCurrency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.isForeignCurrency",
                                          },
                                        }),
                                        _vm.createParams.isForeignCurrency !=
                                          _vm.oldParams.isForeignCurrency &&
                                        _vm.oldParams.isForeignCurrency
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_FOREIGN_CURRENCY",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams.isForeignCurrency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "isForeignCurrency",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.isForeignCurrency",
                                      },
                                    }),
                                    _vm.createParams.isForeignCurrency !=
                                      _vm.contrastParams.isForeignCurrency &&
                                    _vm.contrastParams.isForeignCurrency
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup && _vm.isHappyMealSet
                            ? _c("tr", [
                                _c("td", [
                                  _vm.createParams.isForeignCurrency == "Y"
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v("外币币种"),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        ref: "foreignCurrencyCode_rule",
                                        attrs: {
                                          prop: "foreignCurrencyCode",
                                          rules:
                                            _vm.isHappyMealSet &&
                                            _vm.createParams
                                              .isForeignCurrency == "Y"
                                              ? _vm.rules.foreignCurrencyCode
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "BASE",
                                            field: "CURRENCY_CODE",
                                            disabled:
                                              !_vm.isHappyMealSet ||
                                              _vm.createParams
                                                .isForeignCurrency !== "Y",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.foreignCurrencyCodeChange(
                                                _vm.createParams
                                                  .foreignCurrencyCode
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .foreignCurrencyCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "foreignCurrencyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.foreignCurrencyCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_FOREIGN_CURRENCY",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.foreignCurrencyCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "foreignCurrencyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.foreignCurrencyCode ",
                                          },
                                        }),
                                        _vm.createParams.foreignCurrencyCode !=
                                          _vm.oldParams.foreignCurrencyCode &&
                                        _vm.oldParams.foreignCurrencyCode
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_FOREIGN_CURRENCY",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .foreignCurrencyCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "foreignCurrencyCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.foreignCurrencyCode ",
                                      },
                                    }),
                                    _vm.createParams.foreignCurrencyCode !=
                                      _vm.contrastParams.foreignCurrencyCode &&
                                    _vm.contrastParams.foreignCurrencyCode
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup && _vm.isHappyMealSet
                            ? _c("tr", [
                                _c("td", [
                                  _vm.createParams.isForeignCurrency == "Y"
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v("汇率"),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "exchangeRate",
                                          rules:
                                            _vm.isHappyMealSet &&
                                            _vm.createParams
                                              .isForeignCurrency == "Y"
                                              ? _vm.rules.exchangeRate
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            onkeyup:
                                              "this.value=this.value.match(/\\d+\\.?\\d{0,4}/);",
                                            disabled:
                                              !_vm.isHappyMealSet ||
                                              _vm.createParams
                                                .isForeignCurrency !== "Y",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.exchangeRateBlur(
                                                _vm.createParams.exchangeRate,
                                                _vm.createParams
                                                  .foreignCurrencyAmount
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.exchangeRate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "exchangeRate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.exchangeRate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.exchangeRate ==
                                            _vm.oldParams.exchangeRate
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.exchangeRate) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.exchangeRate ==
                                        _vm.contrastParams.exchangeRate
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.exchangeRate
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isSup && _vm.isHappyMealSet
                            ? _c("tr", [
                                _c("td", [_vm._v("外币金额")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          rules:
                                            _vm.isHappyMealSet &&
                                            _vm.createParams
                                              .isForeignCurrency == "Y"
                                              ? _vm.rules.foreignCurrencyAmount
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            onkeyup:
                                              "this.value=this.value.match(/\\d+\\.?\\d{0,6}/);",
                                            maxlength: "20",
                                            disabled:
                                              !_vm.isHappyMealSet ||
                                              _vm.createParams
                                                .isForeignCurrency !== "Y",
                                            clearable: "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.foreignCurrencyAmountBlur(
                                                _vm.createParams.exchangeRate,
                                                _vm.createParams
                                                  .foreignCurrencyAmount
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .foreignCurrencyAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "foreignCurrencyAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.foreignCurrencyAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .foreignCurrencyAmount ==
                                            _vm.oldParams.foreignCurrencyAmount
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .foreignCurrencyAmount
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .foreignCurrencyAmount ==
                                        _vm.contrastParams.foreignCurrencyAmount
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .foreignCurrencyAmount
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: _vm.$t("material.qualityInformation") } },
                    [
                      _c(
                        "table",
                        { staticStyle: { "padding-top": "15px" } },
                        [
                          _c("tr", { staticStyle: { height: "35px" } }, [
                            _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v(_vm._s(_vm.$t("material.nowVersion"))),
                            ]),
                            _vm.oldRecordExists
                              ? _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.LastVersion"))
                                  ),
                                ])
                              : _vm._e(),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("material.contrast"))),
                            ]),
                          ]),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("material.basicInformation"))
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.$t("material.settlementUnitName"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.createParams.settlementUnitName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.createParams,
                                        "settlementUnitName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "createParams.settlementUnitName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("td"),
                            _c("td"),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.$t("material.tmPlantName"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.createParams.tmPlantName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.createParams,
                                        "tmPlantName",
                                        $$v
                                      )
                                    },
                                    expression: "createParams.tmPlantName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("td"),
                            _c("td"),
                          ]),
                          _c("tr", [
                            _c("td", { staticStyle: { width: "230px" } }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.chineseNameOfProduct"))
                              ),
                            ]),
                            _c(
                              "td",
                              { staticStyle: { width: "230px" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "eightBitCodeName" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", disabled: "" },
                                      model: {
                                        value:
                                          _vm.createParams.eightBitCodeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "eightBitCodeName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.eightBitCodeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    staticStyle: { width: "230px" },
                                    style: {
                                      color:
                                        _vm.createParams.eightBitCodeName ==
                                        _vm.oldParams.eightBitCodeName
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.eightBitCodeName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                staticStyle: { width: "230px" },
                                style: {
                                  color:
                                    _vm.createParams.eightBitCodeName ==
                                    _vm.contrastParams.eightBitCodeName
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams.eightBitCodeName
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.englishNameOfProduct"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "rawProductEName" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.createParams.rawProductEName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "rawProductEName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.rawProductEName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.rawProductEName ==
                                        _vm.oldParams.rawProductEName
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.rawProductEName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.rawProductEName ==
                                    _vm.contrastParams.rawProductEName
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.rawProductEName) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.englishAbbreviationOfProduct"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .rawProductEAbbreviation,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "rawProductEAbbreviation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.rawProductEAbbreviation",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .rawProductEAbbreviation ==
                                            _vm.oldParams
                                              .rawProductEAbbreviation
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .rawProductEAbbreviation
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .rawProductEAbbreviation ==
                                        _vm.contrastParams
                                          .rawProductEAbbreviation
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .rawProductEAbbreviation
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.createParams.isWrin,
                                          expression: "createParams.isWrin",
                                        },
                                      ],
                                    },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(_vm._s(_vm.$t("material.wrinCode"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "wrinCode" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            maxlength: "9",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.wrinInput(
                                                _vm.createParams.wrinCode
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.createParams.wrinCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "wrinCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.wrinCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.wrinCode ==
                                            _vm.oldParams.wrinCode
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.wrinCode) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.wrinCode ==
                                        _vm.contrastParams.wrinCode
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.wrinCode) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.isTraceable"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "isTraceable" } },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          model: {
                                            value: _vm.createParams.isTraceable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "isTraceable",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.isTraceable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.oldParams.isTraceable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "isTraceable",
                                                $$v
                                              )
                                            },
                                            expression: "oldParams.isTraceable",
                                          },
                                        }),
                                        _vm.createParams.isTraceable !=
                                          _vm.oldParams.isTraceable &&
                                        _vm.oldParams.isTraceable
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.contrastParams.isTraceable,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "isTraceable",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.isTraceable",
                                      },
                                    }),
                                    _vm.createParams.isTraceable !=
                                      _vm.contrastParams.isTraceable &&
                                    _vm.contrastParams.isTraceable
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.enterCatellaeSystem")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { prop: "enterCatellaeSystem" },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .enterCatellaeSystem,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "enterCatellaeSystem",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.enterCatellaeSystem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.enterCatellaeSystem,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "enterCatellaeSystem",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.enterCatellaeSystem",
                                          },
                                        }),
                                        _vm.createParams.enterCatellaeSystem !=
                                          _vm.oldParams.enterCatellaeSystem &&
                                        _vm.oldParams.enterCatellaeSystem
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .enterCatellaeSystem,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "enterCatellaeSystem",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.enterCatellaeSystem",
                                      },
                                    }),
                                    _vm.createParams.enterCatellaeSystem !=
                                      _vm.contrastParams.enterCatellaeSystem &&
                                    _vm.contrastParams.enterCatellaeSystem
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop && _vm.emplFlag !== "S"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.HasMultiShelfLife"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "hasMultiShelfLife" } },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .hasMultiShelfLife,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "hasMultiShelfLife",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.hasMultiShelfLife",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "IS_NOT",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.hasMultiShelfLife,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "hasMultiShelfLife",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.hasMultiShelfLife",
                                          },
                                        }),
                                        _vm.createParams.hasMultiShelfLife !=
                                          _vm.oldParams.hasMultiShelfLife &&
                                        _vm.oldParams.hasMultiShelfLife
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams.hasMultiShelfLife,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "hasMultiShelfLife",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.hasMultiShelfLife",
                                      },
                                    }),
                                    _vm.createParams.hasMultiShelfLife !=
                                      _vm.contrastParams.hasMultiShelfLife &&
                                    _vm.contrastParams.hasMultiShelfLife
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(_vm.$t("material.productDetails"))),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticStyle: { width: "250px" } }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.temperature"))),
                            ]),
                            _c(
                              "td",
                              { staticStyle: { width: "250px" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "temperature" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "COMMON",
                                        field: "TEMPERATURE",
                                      },
                                      model: {
                                        value: _vm.createParams.temperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "temperature",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.temperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "COMMON",
                                        field: "TEMPERATURE",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.temperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "temperature",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.temperature",
                                      },
                                    }),
                                    _vm.createParams.temperature !=
                                      _vm.oldParams.temperature &&
                                    _vm.oldParams.temperature
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "COMMON",
                                    field: "TEMPERATURE",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.temperature,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "temperature",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.temperature",
                                  },
                                }),
                                _vm.createParams.temperature !=
                                  _vm.contrastParams.temperature &&
                                _vm.contrastParams.temperature
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          !_vm.isPop
                            ? [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.$t("material.secondShelfLife"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              clearable: "",
                                              oninput:
                                                "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams
                                                  .secondShelfLife,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "secondShelfLife",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.secondShelfLife",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .secondShelfLife ==
                                              _vm.oldParams.secondShelfLife
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.oldParams.secondShelfLife
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.secondShelfLife ==
                                          _vm.contrastParams.secondShelfLife
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams.secondShelfLife
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("material.secondShelfLifeUnit")
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SHELF_LIFE_UOM",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams
                                                  .secondShelfLifeUnit,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "secondShelfLifeUnit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.secondShelfLifeUnit",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SHELF_LIFE_UOM",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.oldParams
                                                  .secondShelfLifeUnit,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.oldParams,
                                                  "secondShelfLifeUnit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oldParams.secondShelfLifeUnit",
                                            },
                                          }),
                                          _vm.createParams
                                            .secondShelfLifeUnit !=
                                            _vm.oldParams.secondShelfLifeUnit &&
                                          _vm.oldParams.secondShelfLifeUnit
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "SHELF_LIFE_UOM",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.contrastParams
                                              .secondShelfLifeUnit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.contrastParams,
                                              "secondShelfLifeUnit",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contrastParams.secondShelfLifeUnit",
                                        },
                                      }),
                                      _vm.createParams.secondShelfLifeUnit !=
                                        _vm.contrastParams
                                          .secondShelfLifeUnit &&
                                      _vm.contrastParams.secondShelfLifeUnit
                                        ? _c("span", [_vm._v("!")])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(
                                      _vm._s(_vm.$t("material.firstShelfLife"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "firstShelfLife" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              oninput:
                                                "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                            },
                                            on: {
                                              blur: _vm.computMinimumDcReceivingValidity,
                                            },
                                            model: {
                                              value:
                                                _vm.createParams.firstShelfLife,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "firstShelfLife",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.firstShelfLife",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.firstShelfLife ==
                                              _vm.oldParams.firstShelfLife
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.oldParams.firstShelfLife
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.firstShelfLife ==
                                          _vm.contrastParams.firstShelfLife
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams.firstShelfLife
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("material.shelfLifeAfterThawing")
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              oninput:
                                                "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams
                                                  .shelfLifeAfterThawing,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "shelfLifeAfterThawing",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.shelfLifeAfterThawing",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .shelfLifeAfterThawing ==
                                              _vm.oldParams
                                                .shelfLifeAfterThawing
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.oldParams
                                                  .shelfLifeAfterThawing
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams
                                            .shelfLifeAfterThawing ==
                                          _vm.contrastParams
                                            .shelfLifeAfterThawing
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams
                                              .shelfLifeAfterThawing
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "material.shelfLifeUnitAfterThawing"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SHELF_LIFE_UOM",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams
                                                  .shelfLifeUnitAfterThawing,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "shelfLifeUnitAfterThawing",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.shelfLifeUnitAfterThawing",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "SHELF_LIFE_UOM",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.oldParams
                                                  .shelfLifeUnitAfterThawing,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.oldParams,
                                                  "shelfLifeUnitAfterThawing",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oldParams.shelfLifeUnitAfterThawing",
                                            },
                                          }),
                                          _vm.createParams
                                            .shelfLifeUnitAfterThawing !=
                                            _vm.oldParams
                                              .shelfLifeUnitAfterThawing &&
                                          _vm.oldParams
                                            .shelfLifeUnitAfterThawing
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "SHELF_LIFE_UOM",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.contrastParams
                                              .shelfLifeUnitAfterThawing,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.contrastParams,
                                              "shelfLifeUnitAfterThawing",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contrastParams.shelfLifeUnitAfterThawing",
                                        },
                                      }),
                                      _vm.createParams
                                        .shelfLifeUnitAfterThawing !=
                                        _vm.contrastParams
                                          .shelfLifeUnitAfterThawing &&
                                      _vm.contrastParams
                                        .shelfLifeUnitAfterThawing
                                        ? _c("span", [_vm._v("!")])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.$t("material.thawingTime"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              clearable: "",
                                              oninput:
                                                "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams.thawingTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "thawingTime",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.thawingTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.thawingTime ==
                                              _vm.oldParams.thawingTime
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.oldParams.thawingTime
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.thawingTime ==
                                          _vm.contrastParams.thawingTime
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contrastParams.thawingTime
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("material.formula1"))),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "200",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.createParams.formula1,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "formula1",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.formula1",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.formula1 ==
                                              _vm.oldParams.formula1
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.oldParams.formula1) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.formula1 ==
                                          _vm.contrastParams.formula1
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.contrastParams.formula1) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("material.formula2"))),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.createParams.formula2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "formula2",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.formula2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.formula2 ==
                                              _vm.oldParams.formula2
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.oldParams.formula2) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.formula2 ==
                                          _vm.contrastParams.formula2
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.contrastParams.formula2) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("material.formula3"))),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.createParams.formula3,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "formula3",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.formula3",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.formula3 ==
                                              _vm.oldParams.formula3
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.oldParams.formula3) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.formula3 ==
                                          _vm.contrastParams.formula3
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.contrastParams.formula3) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("material.formula4"))),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.createParams.formula4,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "formula4",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "createParams.formula4",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.formula4 ==
                                              _vm.oldParams.formula4
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.oldParams.formula4) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          _vm.createParams.formula4 ==
                                          _vm.contrastParams.formula4
                                            ? ""
                                            : "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.contrastParams.formula4) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("material.isNeedThaw"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams.isNeedThaw,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "isNeedThaw",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.isNeedThaw",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.oldParams.isNeedThaw,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.oldParams,
                                                      "isNeedThaw",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "oldParams.isNeedThaw",
                                                },
                                              }),
                                              _vm.createParams.isNeedThaw !=
                                                _vm.oldParams.isNeedThaw &&
                                              _vm.oldParams.isNeedThaw
                                                ? _c("span", [_vm._v("!")])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "IS_NOT",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.contrastParams.isNeedThaw,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contrastParams,
                                                  "isNeedThaw",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contrastParams.isNeedThaw",
                                            },
                                          }),
                                          _vm.createParams.isNeedThaw !=
                                            _vm.contrastParams.isNeedThaw &&
                                          _vm.contrastParams.isNeedThaw
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "material.isNeedPreparationTime"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .isNeedPreparationTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "isNeedPreparationTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.isNeedPreparationTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.oldParams
                                                      .isNeedPreparationTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.oldParams,
                                                      "isNeedPreparationTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "oldParams.isNeedPreparationTime",
                                                },
                                              }),
                                              _vm.createParams
                                                .isNeedPreparationTime !=
                                                _vm.oldParams
                                                  .isNeedPreparationTime &&
                                              _vm.oldParams
                                                .isNeedPreparationTime
                                                ? _c("span", [_vm._v("!")])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "IS_NOT",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.contrastParams
                                                  .isNeedPreparationTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contrastParams,
                                                  "isNeedPreparationTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contrastParams.isNeedPreparationTime",
                                            },
                                          }),
                                          _vm.createParams
                                            .isNeedPreparationTime !=
                                            _vm.contrastParams
                                              .isNeedPreparationTime &&
                                          _vm.contrastParams
                                            .isNeedPreparationTime
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("material.isHarmful"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams.isHarmful,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "isHarmful",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.isHarmful",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            [
                                              _c("ic-select", {
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "IS_NOT",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.oldParams.isHarmful,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.oldParams,
                                                      "isHarmful",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "oldParams.isHarmful",
                                                },
                                              }),
                                              _vm.createParams.isHarmful !=
                                                _vm.oldParams.isHarmful &&
                                              _vm.oldParams.isHarmful
                                                ? _c("span", [_vm._v("!")])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "IS_NOT",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.contrastParams.isHarmful,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contrastParams,
                                                  "isHarmful",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contrastParams.isHarmful",
                                            },
                                          }),
                                          _vm.createParams.isHarmful !=
                                            _vm.contrastParams.isHarmful &&
                                          _vm.contrastParams.isHarmful
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("material.taste"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "200",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value: _vm.createParams.taste,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "taste",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.taste",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams.taste ==
                                                  _vm.oldParams.taste
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.oldParams.taste) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.taste ==
                                              _vm.contrastParams.taste
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.contrastParams.taste) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("material.shape"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "40",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value: _vm.createParams.shape,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "shape",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.shape",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams.shape ==
                                                  _vm.oldParams.shape
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.oldParams.shape) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.shape ==
                                              _vm.contrastParams.shape
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.contrastParams.shape) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("material.color"))
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "100",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value: _vm.createParams.color,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "color",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.color",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams.color ==
                                                  _vm.oldParams.color
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.oldParams.color) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams.color ==
                                              _vm.contrastParams.color
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.contrastParams.color) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("tr", [
                                  _c("td", [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(
                                      _vm._s(_vm.$t("material.validityDate"))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "validityDate" } },
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "VALIDITY_DATE",
                                            },
                                            model: {
                                              value:
                                                _vm.createParams.validityDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.createParams,
                                                  "validityDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "createParams.validityDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.oldRecordExists
                                    ? _c(
                                        "td",
                                        [
                                          _c("ic-select", {
                                            attrs: {
                                              clearable: "",
                                              table: "TM_MATERIAL_RECORD",
                                              field: "VALIDITY_DATE",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.oldParams.validityDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.oldParams,
                                                  "validityDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oldParams.validityDate",
                                            },
                                          }),
                                          _vm.createParams.validityDate !=
                                            _vm.oldParams.validityDate &&
                                          _vm.oldParams.validityDate
                                            ? _c("span", [_vm._v("!")])
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_MATERIAL_RECORD",
                                          field: "VALIDITY_DATE",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.contrastParams.validityDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.contrastParams,
                                              "validityDate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contrastParams.validityDate",
                                        },
                                      }),
                                      _vm.createParams.validityDate !=
                                        _vm.contrastParams.validityDate &&
                                      _vm.contrastParams.validityDate
                                        ? _c("span", [_vm._v("!")])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "material.onlineSecondShelfLife"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .onlineSecondShelfLife,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "onlineSecondShelfLife",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.onlineSecondShelfLife",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams
                                                    .onlineSecondShelfLife ==
                                                  _vm.oldParams
                                                    .onlineSecondShelfLife
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.oldParams
                                                      .onlineSecondShelfLife
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .onlineSecondShelfLife ==
                                              _vm.contrastParams
                                                .onlineSecondShelfLife
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.contrastParams
                                                  .onlineSecondShelfLife
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("material.preparationMethod")
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "200",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .preparationMethod,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "preparationMethod",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.preparationMethod",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams
                                                    .preparationMethod ==
                                                  _vm.oldParams
                                                    .preparationMethod
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.oldParams
                                                      .preparationMethod
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .preparationMethod ==
                                              _vm.contrastParams
                                                .preparationMethod
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.contrastParams
                                                  .preparationMethod
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isPop
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("material.preparationTime")
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  clearable: "",
                                                  oninput:
                                                    "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                                },
                                                model: {
                                                  value:
                                                    _vm.createParams
                                                      .preparationTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.createParams,
                                                      "preparationTime",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "createParams.preparationTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.oldRecordExists
                                        ? _c(
                                            "td",
                                            {
                                              style: {
                                                color:
                                                  _vm.createParams
                                                    .preparationTime ==
                                                  _vm.oldParams.preparationTime
                                                    ? ""
                                                    : "red",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.oldParams
                                                      .preparationTime
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          style: {
                                            color:
                                              _vm.createParams
                                                .preparationTime ==
                                              _vm.contrastParams.preparationTime
                                                ? ""
                                                : "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.contrastParams
                                                  .preparationTime
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("material.minimumStorageTemperature")
                                )
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "minimumStorageTemperature",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { maxLength: "10" },
                                      model: {
                                        value:
                                          _vm.createParams
                                            .minimumStorageTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "minimumStorageTemperature",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.minimumStorageTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .minimumStorageTemperature ==
                                        _vm.oldParams.minimumStorageTemperature
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldParams
                                            .minimumStorageTemperature
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams
                                      .minimumStorageTemperature ==
                                    _vm.contrastParams.minimumStorageTemperature
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams
                                        .minimumStorageTemperature
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("material.maximumStorageTemperature")
                                )
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "maximumStorageTemperature",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { maxLength: "10" },
                                      model: {
                                        value:
                                          _vm.createParams
                                            .maximumStorageTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "maximumStorageTemperature",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.maximumStorageTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .maximumStorageTemperature ==
                                        _vm.oldParams.maximumStorageTemperature
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldParams
                                            .maximumStorageTemperature
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams
                                      .maximumStorageTemperature ==
                                    _vm.contrastParams.maximumStorageTemperature
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams
                                        .maximumStorageTemperature
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("material.yieldInformation"))
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.mcdBuyingUnit"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "mcdBuyingUnit" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MCD_BUYING_UNIT",
                                      },
                                      model: {
                                        value: _vm.createParams.mcdBuyingUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "mcdBuyingUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.mcdBuyingUnit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MCD_BUYING_UNIT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.mcdBuyingUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "mcdBuyingUnit",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.mcdBuyingUnit",
                                      },
                                    }),
                                    _vm.createParams.mcdBuyingUnit !=
                                      _vm.oldParams.mcdBuyingUnit &&
                                    _vm.oldParams.mcdBuyingUnit
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "MCD_BUYING_UNIT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.mcdBuyingUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "mcdBuyingUnit",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.mcdBuyingUnit",
                                  },
                                }),
                                _vm.createParams.mcdBuyingUnit !=
                                  _vm.contrastParams.mcdBuyingUnit &&
                                _vm.contrastParams.mcdBuyingUnit
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.$t("material.uom")))]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "uom" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        table: "TM_FIVE_BIT_CODE",
                                        field: "UOM",
                                        disabled: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.createParams.uom,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.createParams, "uom", $$v)
                                        },
                                        expression: "createParams.uom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_FIVE_BIT_CODE",
                                        field: "UOM",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.uom,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.oldParams, "uom", $$v)
                                        },
                                        expression: "oldParams.uom",
                                      },
                                    }),
                                    _vm.createParams.uom != _vm.oldParams.uom &&
                                    _vm.oldParams.uom
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_FIVE_BIT_CODE",
                                    field: "UOM",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.uom,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contrastParams, "uom", $$v)
                                    },
                                    expression: "contrastParams.uom",
                                  },
                                }),
                                _vm.createParams.uom !=
                                  _vm.contrastParams.uom &&
                                _vm.contrastParams.uom
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.$t("material.standardCopiesUom"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "standardCopiesUom" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        value: _vm._f("toFixed")(
                                          _vm.createParams.standardCopiesUom,
                                          2
                                        ),
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.createParams.standardCopiesUom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "standardCopiesUom",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.standardCopiesUom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.standardCopiesUom ==
                                        _vm.oldParams.standardCopiesUom
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldParams.standardCopiesUom
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.standardCopiesUom ==
                                    _vm.contrastParams.standardCopiesUom
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams.standardCopiesUom
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.quantityUomInnerNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { prop: "quantityUomInnerNum" },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          on: {
                                            blur: _vm.computeQuantityUomOutsourceNum,
                                            clear: _vm.clearQuantityUomInnerNum,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .quantityUomInnerNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "quantityUomInnerNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.quantityUomInnerNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .quantityUomInnerNum ==
                                            _vm.oldParams.quantityUomInnerNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.quantityUomInnerNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.quantityUomInnerNum ==
                                        _vm.contrastParams.quantityUomInnerNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.quantityUomInnerNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.quantityUomOutsourceNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "quantityUomOutsourceNum",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .quantityUomOutsourceNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "quantityUomOutsourceNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.quantityUomOutsourceNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .quantityUomOutsourceNum ==
                                            _vm.oldParams
                                              .quantityUomOutsourceNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .quantityUomOutsourceNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .quantityUomOutsourceNum ==
                                        _vm.contrastParams
                                          .quantityUomOutsourceNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .quantityUomOutsourceNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.quantityInnerGoodsNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .quantityInnerGoodsNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "quantityInnerGoodsNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.quantityInnerGoodsNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .quantityInnerGoodsNum ==
                                            _vm.oldParams.quantityInnerGoodsNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .quantityInnerGoodsNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .quantityInnerGoodsNum ==
                                        _vm.contrastParams.quantityInnerGoodsNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .quantityInnerGoodsNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _c("span", [_vm._v("*")]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.outerPackageContainsNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "outerPackageContainsNum",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          on: {
                                            blur: _vm.computeQuantityUomOutsourceNum,
                                            clear: _vm.clearQuantityUomInnerNum,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .outerPackageContainsNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "outerPackageContainsNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.outerPackageContainsNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .outerPackageContainsNum ==
                                            _vm.oldParams
                                              .outerPackageContainsNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .outerPackageContainsNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .outerPackageContainsNum ==
                                        _vm.contrastParams
                                          .outerPackageContainsNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .outerPackageContainsNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.stackingHeightInsidePackage"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .stackingHeightInsidePackage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "stackingHeightInsidePackage",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.stackingHeightInsidePackage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .stackingHeightInsidePackage ==
                                            _vm.oldParams
                                              .stackingHeightInsidePackage
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .stackingHeightInsidePackage
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .stackingHeightInsidePackage ==
                                        _vm.contrastParams
                                          .stackingHeightInsidePackage
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .stackingHeightInsidePackage
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.quantityInnerPackingNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .quantityInnerPackingNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "quantityInnerPackingNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.quantityInnerPackingNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .quantityInnerPackingNum ==
                                            _vm.oldParams
                                              .quantityInnerPackingNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .quantityInnerPackingNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .quantityInnerPackingNum ==
                                        _vm.contrastParams
                                          .quantityInnerPackingNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .quantityInnerPackingNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.$t("material.yield"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value: _vm.createParams.yield,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "yield",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.yield",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.yield ==
                                            _vm.oldParams.yield
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.yield) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.yield ==
                                        _vm.contrastParams.yield
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.yield) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.preferentialYield"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.blurPreferentialYield(
                                                $event
                                              )
                                            },
                                            clear: _vm.clearPreferentialYield,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .preferentialYield,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "preferentialYield",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.preferentialYield",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .preferentialYield ==
                                            _vm.oldParams.preferentialYield
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.preferentialYield
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.preferentialYield ==
                                        _vm.contrastParams.preferentialYield
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.preferentialYield
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("material.storageInformation"))
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(_vm.$t("material.dcManagementUnit"))
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "dcManagementUnit" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MCD_BUYING_UNIT",
                                      },
                                      model: {
                                        value:
                                          _vm.createParams.dcManagementUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "dcManagementUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.dcManagementUnit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "MCD_BUYING_UNIT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.dcManagementUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "dcManagementUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "oldParams.dcManagementUnit",
                                      },
                                    }),
                                    _vm.createParams.dcManagementUnit !=
                                      _vm.oldParams.dcManagementUnit &&
                                    _vm.oldParams.dcManagementUnit
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: " TM_MATERIAL_RECORD",
                                    field: "MCD_BUYING_UNIT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.dcManagementUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "dcManagementUnit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "contrastParams.dcManagementUnit",
                                  },
                                }),
                                _vm.createParams.dcManagementUnit !=
                                  _vm.contrastParams.dcManagementUnit &&
                                _vm.contrastParams.dcManagementUnit
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("material.packagingInformation"))
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.isInnerPacking"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isInnerPacking" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                      },
                                      on: { change: _vm.changeIsInnerPacking },
                                      model: {
                                        value: _vm.createParams.isInnerPacking,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "isInnerPacking",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "createParams.isInnerPacking",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.isInnerPacking,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "isInnerPacking",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.isInnerPacking",
                                      },
                                    }),
                                    _vm.createParams.isInnerPacking !=
                                      _vm.oldParams.isInnerPacking &&
                                    _vm.oldParams.isInnerPacking
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "IS_NOT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.isInnerPacking,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "isInnerPacking",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.isInnerPacking",
                                  },
                                }),
                                _vm.createParams.isInnerPacking !=
                                  _vm.contrastParams.isInnerPacking &&
                                _vm.contrastParams.isInnerPacking
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm.createParams.isInnerPacking == "N" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.productLength"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        key: _vm.productLength,
                                        attrs: { prop: "productLength" },
                                      },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.productLength =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .productLength,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.productLength =
                                                _vm.onInput(
                                                  _vm.createParams.productLength
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.productLength,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productLength",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productLength",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.productLength ==
                                            _vm.oldParams.productLength
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.productLength
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.productLength ==
                                        _vm.contrastParams.productLength
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.productLength
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "N" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.productWidth"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "productWidth" } },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.productWidth =
                                                _vm.onBlur(
                                                  _vm.createParams.productWidth,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.productWidth =
                                                _vm.onInput(
                                                  _vm.createParams.productWidth
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.productWidth,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productWidth",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productWidth",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.productWidth ==
                                            _vm.oldParams.productWidth
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.productWidth) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.productWidth ==
                                        _vm.contrastParams.productWidth
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.productWidth
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "N" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.productHeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "productHeight" } },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.productHeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .productHeight,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.productHeight =
                                                _vm.onInput(
                                                  _vm.createParams.productHeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.productHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.productHeight ==
                                            _vm.oldParams.productHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.productHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.productHeight ==
                                        _vm.contrastParams.productHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.productHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "N"
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.productWeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "productWeight" } },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.productWeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .productWeight,
                                                  6
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.productWeight =
                                                _vm.onInput2(
                                                  _vm.createParams.productWeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.productWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.productWeight ==
                                            _vm.oldParams.productWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.productWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.productWeight ==
                                        _vm.contrastParams.productWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.productWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "N" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.productGrossWeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "productGrossWeight" } },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.productGrossWeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .productGrossWeight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.productGrossWeight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .productGrossWeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .productGrossWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productGrossWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productGrossWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .productGrossWeight ==
                                            _vm.oldParams.productGrossWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.productGrossWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.productGrossWeight ==
                                        _vm.contrastParams.productGrossWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.productGrossWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("innerPackingType")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.innerPackingType"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        key: _vm.innerPackingType,
                                        attrs: {
                                          prop: "innerPackingType",
                                          rules: _vm.isFieldRequired(
                                            "innerPackingType"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "INNER_PACKING_TYPE",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.innerPackingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "INNER_PACKING_TYPE",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams.innerPackingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "innerPackingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.innerPackingType",
                                          },
                                        }),
                                        _vm.createParams.innerPackingType !=
                                          _vm.oldParams.innerPackingType &&
                                        _vm.oldParams.innerPackingType
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "INNER_PACKING_TYPE",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams.innerPackingType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "innerPackingType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.innerPackingType",
                                      },
                                    }),
                                    _vm.createParams.innerPackingType !=
                                      _vm.contrastParams.innerPackingType &&
                                    _vm.contrastParams.innerPackingType
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.innerPackageLength")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackageLength =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackageLength,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackageLength =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .innerPackageLength
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackageLength,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackageLength",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackageLength",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackageLength ==
                                            _vm.oldParams.innerPackageLength
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.innerPackageLength
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.innerPackageLength ==
                                        _vm.contrastParams.innerPackageLength
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.innerPackageLength
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.innerPackingWidth"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackingWidth =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackingWidth,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackingWidth =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .innerPackingWidth
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackingWidth,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingWidth",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingWidth",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackingWidth ==
                                            _vm.oldParams.innerPackingWidth
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.innerPackingWidth
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.innerPackingWidth ==
                                        _vm.contrastParams.innerPackingWidth
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.innerPackingWidth
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.innerPackingHeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackingHeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackingHeight,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackingHeight =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .innerPackingHeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackingHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackingHeight ==
                                            _vm.oldParams.innerPackingHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.innerPackingHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.innerPackingHeight ==
                                        _vm.contrastParams.innerPackingHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.innerPackingHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.innerPackingWeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackingWeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackingWeight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackingWeight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .innerPackingWeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackingWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackingWeight ==
                                            _vm.oldParams.innerPackingWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.innerPackingWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.innerPackingWeight ==
                                        _vm.contrastParams.innerPackingWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.innerPackingWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.innerPackingGrossWeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackingGrossWeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackingGrossWeight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackingGrossWeight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .innerPackingGrossWeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackingGrossWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingGrossWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingGrossWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackingGrossWeight ==
                                            _vm.oldParams
                                              .innerPackingGrossWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .innerPackingGrossWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .innerPackingGrossWeight ==
                                        _vm.contrastParams
                                          .innerPackingGrossWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .innerPackingGrossWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.createParams.isInnerPacking == "Y" && !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.innerPackingCapacity")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.innerPackingCapacity =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .innerPackingCapacity,
                                                  6
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.innerPackingCapacity =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .innerPackingCapacity
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .innerPackingCapacity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "innerPackingCapacity",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.innerPackingCapacity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .innerPackingCapacity ==
                                            _vm.oldParams.innerPackingCapacity
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.innerPackingCapacity
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.innerPackingCapacity ==
                                        _vm.contrastParams.innerPackingCapacity
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .innerPackingCapacity
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.$t("material.language"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.createParams.language,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "language",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.language",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.language ==
                                            _vm.oldParams.language
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.language) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.language ==
                                        _vm.contrastParams.language
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.language) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.$t("material.graphics"))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.createParams.graphics,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "graphics",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "createParams.graphics",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.graphics ==
                                            _vm.oldParams.graphics
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.oldParams.graphics) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.graphics ==
                                        _vm.contrastParams.graphics
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contrastParams.graphics) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("productPackagingType")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.productPackagingType")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "productPackagingType",
                                          rules: _vm.isFieldRequired(
                                            "productPackagingType"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "PRODUCT_PACKAGING_TYPE",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .productPackagingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productPackagingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productPackagingType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field: "PRODUCT_PACKAGING_TYPE",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .productPackagingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "productPackagingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.productPackagingType",
                                          },
                                        }),
                                        _vm.createParams.productPackagingType !=
                                          _vm.oldParams.productPackagingType &&
                                        _vm.oldParams.productPackagingType
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "PRODUCT_PACKAGING_TYPE",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .productPackagingType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "productPackagingType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.productPackagingType",
                                      },
                                    }),
                                    _vm.createParams.productPackagingType !=
                                      _vm.contrastParams.productPackagingType &&
                                    _vm.contrastParams.productPackagingType
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("externalPackagingLength")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.externalPackagingLength")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "externalPackagingLength",
                                          rules: _vm.isFieldRequired(
                                            "externalPackagingLength"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.externalPackagingLength =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .externalPackagingLength,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.externalPackagingLength =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .externalPackagingLength
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .externalPackagingLength,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "externalPackagingLength",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.externalPackagingLength",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .externalPackagingLength ==
                                            _vm.oldParams
                                              .externalPackagingLength
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .externalPackagingLength
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .externalPackagingLength ==
                                        _vm.contrastParams
                                          .externalPackagingLength
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .externalPackagingLength
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("externalPackagingWidth")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.externalPackagingWidth")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "externalPackagingWidth",
                                          rules: _vm.isFieldRequired(
                                            "externalPackagingWidth"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.externalPackagingWidth =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .externalPackagingWidth,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.externalPackagingWidth =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .externalPackagingWidth
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .externalPackagingWidth,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "externalPackagingWidth",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.externalPackagingWidth",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .externalPackagingWidth ==
                                            _vm.oldParams.externalPackagingWidth
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .externalPackagingWidth
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .externalPackagingWidth ==
                                        _vm.contrastParams
                                          .externalPackagingWidth
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .externalPackagingWidth
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("externalPackagingHeight")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.externalPackagingHeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "externalPackagingHeight",
                                          rules: _vm.isFieldRequired(
                                            "externalPackagingHeight"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.externalPackagingHeight =
                                                _vm.onBlur(
                                                  _vm.createParams
                                                    .externalPackagingHeight,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.externalPackagingHeight =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .externalPackagingHeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .externalPackagingHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "externalPackagingHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.externalPackagingHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .externalPackagingHeight ==
                                            _vm.oldParams
                                              .externalPackagingHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .externalPackagingHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .externalPackagingHeight ==
                                        _vm.contrastParams
                                          .externalPackagingHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .externalPackagingHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired(
                                    "externalPackagingNetweight"
                                  )
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.externalPackagingNetweight"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "externalPackagingNetweight",
                                          rules: _vm.isFieldRequired(
                                            "externalPackagingNetweight"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.externalPackagingNetweight =
                                                _vm.externalPackagingNetweightBlur(
                                                  _vm.createParams
                                                    .externalPackagingNetweight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.externalPackagingNetweight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .externalPackagingNetweight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .externalPackagingNetweight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "externalPackagingNetweight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.externalPackagingNetweight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .externalPackagingNetweight ==
                                            _vm.oldParams
                                              .externalPackagingNetweight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .externalPackagingNetweight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .externalPackagingNetweight ==
                                        _vm.contrastParams
                                          .externalPackagingNetweight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .externalPackagingNetweight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired(
                                    "externalPackagingGrossweight"
                                  )
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.externalPackagingGrossweight"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "externalPackagingGrossweight",
                                          rules: _vm.isFieldRequired(
                                            "externalPackagingGrossweight"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.externalPackagingGrossweight =
                                                _vm.externalPackagingGrossweightBlur(
                                                  _vm.createParams
                                                    .externalPackagingGrossweight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.externalPackagingGrossweight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .externalPackagingGrossweight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .externalPackagingGrossweight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "externalPackagingGrossweight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.externalPackagingGrossweight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .externalPackagingGrossweight ==
                                            _vm.oldParams
                                              .externalPackagingGrossweight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .externalPackagingGrossweight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .externalPackagingGrossweight ==
                                        _vm.contrastParams
                                          .externalPackagingGrossweight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .externalPackagingGrossweight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "material.productTransportPalletType"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "productTransportPalletType",
                                          rules:
                                            _vm.createParams.disType ==
                                              "SUPPLIER" || _vm.isRequired
                                              ? _vm.rules
                                                  .productTransportPalletType
                                              : [{ required: false }],
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field:
                                              "PRODUCT_TRANSPORT_PALLET_TYPE",
                                          },
                                          on: {
                                            change:
                                              _vm.changeProductTransportPalletType,
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .productTransportPalletType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "productTransportPalletType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "createParams.productTransportPalletType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      [
                                        _c("ic-select", {
                                          attrs: {
                                            clearable: "",
                                            table: "TM_MATERIAL_RECORD",
                                            field:
                                              "PRODUCT_TRANSPORT_PALLET_TYPE",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.oldParams
                                                .productTransportPalletType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.oldParams,
                                                "productTransportPalletType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oldParams.productTransportPalletType",
                                          },
                                        }),
                                        _vm.createParams
                                          .productTransportPalletType !=
                                          _vm.oldParams
                                            .productTransportPalletType &&
                                        _vm.oldParams.productTransportPalletType
                                          ? _c("span", [_vm._v("!")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "PRODUCT_TRANSPORT_PALLET_TYPE",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.contrastParams
                                            .productTransportPalletType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contrastParams,
                                            "productTransportPalletType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contrastParams.productTransportPalletType",
                                      },
                                    }),
                                    _vm.createParams
                                      .productTransportPalletType !=
                                      _vm.contrastParams
                                        .productTransportPalletType &&
                                    _vm.contrastParams
                                      .productTransportPalletType
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("palletLayerBoxNumber")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.palletLayerBoxNumber")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletLayerBoxNumber",
                                          rules: _vm.isFieldRequired(
                                            "palletLayerBoxNumber"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletLayerBoxNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletLayerBoxNumber",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletLayerBoxNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletLayerBoxNumber ==
                                            _vm.oldParams.palletLayerBoxNumber
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletLayerBoxNumber
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletLayerBoxNumber ==
                                        _vm.contrastParams.palletLayerBoxNumber
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .palletLayerBoxNumber
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("palletLayerNumber")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.palletLayerNumber"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletLayerNumber",
                                          rules: _vm.isFieldRequired(
                                            "palletLayerNumber"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletLayerNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletLayerNumber",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletLayerNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletLayerNumber ==
                                            _vm.oldParams.palletLayerNumber
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletLayerNumber
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletLayerNumber ==
                                        _vm.contrastParams.palletLayerNumber
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.palletLayerNumber
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("palletItemsLength")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.palletItemsLength"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletItemsLength",
                                          rules: _vm.isFieldRequired(
                                            "palletItemsLength"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.palletItemsLength =
                                                _vm.blurPalletItemsLength(
                                                  _vm.createParams
                                                    .palletItemsLength,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.palletItemsLength =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .palletItemsLength
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletItemsLength,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletItemsLength",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletItemsLength",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletItemsLength ==
                                            _vm.oldParams.palletItemsLength
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletItemsLength
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletItemsLength ==
                                        _vm.contrastParams.palletItemsLength
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.palletItemsLength
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("palletItemsWidth")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.palletItemsWidth"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletItemsWidth",
                                          rules: _vm.isFieldRequired(
                                            "palletItemsWidth"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.palletItemsWidth =
                                                _vm.blurPalletItemsWidth(
                                                  _vm.createParams
                                                    .palletItemsWidth,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.palletItemsWidth =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .palletItemsWidth
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.palletItemsWidth,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletItemsWidth",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletItemsWidth",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.palletItemsWidth ==
                                            _vm.oldParams.palletItemsWidth
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletItemsWidth
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletItemsWidth ==
                                        _vm.contrastParams.palletItemsWidth
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.palletItemsWidth
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("palletItemsHeight")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.palletItemsHeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletItemsHeight",
                                          rules: _vm.isFieldRequired(
                                            "palletItemsHeight"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.palletItemsHeight =
                                                _vm.blurPalletItemsHeight(
                                                  _vm.createParams
                                                    .palletItemsHeight,
                                                  2
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.palletItemsHeight =
                                                _vm.onInput(
                                                  _vm.createParams
                                                    .palletItemsHeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletItemsHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletItemsHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletItemsHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletItemsHeight ==
                                            _vm.oldParams.palletItemsHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletItemsHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletItemsHeight ==
                                        _vm.contrastParams.palletItemsHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.palletItemsHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.palletItemsWeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "palletItemsWeight" } },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.palletItemsWeight =
                                                _vm.blurPalletItemsWeight(
                                                  _vm.createParams
                                                    .palletItemsWeight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.palletItemsWeight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .palletItpalletItemsWeightemsHeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletItemsWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletItemsWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletItemsWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletItemsWeight ==
                                            _vm.oldParams.palletItemsWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.palletItemsWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.palletItemsWeight ==
                                        _vm.contrastParams.palletItemsWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.palletItemsWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.palletItemsGrossWeight")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "palletItemsGrossWeight",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          on: {
                                            blur: function ($event) {
                                              _vm.createParams.palletItemsGrossWeight =
                                                _vm.blurPalletItemsGrossWeight(
                                                  _vm.createParams
                                                    .palletItemsGrossWeight,
                                                  3
                                                )
                                            },
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              _vm.createParams.palletItemsGrossWeight =
                                                _vm.onInput2(
                                                  _vm.createParams
                                                    .palletItemsGrossWeight
                                                )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .palletItemsGrossWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "palletItemsGrossWeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.palletItemsGrossWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .palletItemsGrossWeight ==
                                            _vm.oldParams.palletItemsGrossWeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .palletItemsGrossWeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .palletItemsGrossWeight ==
                                        _vm.contrastParams
                                          .palletItemsGrossWeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .palletItemsGrossWeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.transportStackingLayers")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "transportStackingLayers",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .transportStackingLayers,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "transportStackingLayers",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.transportStackingLayers",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .transportStackingLayers ==
                                            _vm.oldParams
                                              .transportStackingLayers
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .transportStackingLayers
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .transportStackingLayers ==
                                        _vm.contrastParams
                                          .transportStackingLayers
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .transportStackingLayers
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.storageStackLayersNum")
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "storageStackLayersNum",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams
                                                .storageStackLayersNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "storageStackLayersNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.storageStackLayersNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams
                                              .storageStackLayersNum ==
                                            _vm.oldParams.storageStackLayersNum
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams
                                                .storageStackLayersNum
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .storageStackLayersNum ==
                                        _vm.contrastParams.storageStackLayersNum
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams
                                            .storageStackLayersNum
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("material.transportHeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "transportHeight" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.transportHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "transportHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.transportHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.transportHeight ==
                                            _vm.oldParams.transportHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.transportHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.transportHeight ==
                                        _vm.contrastParams.transportHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.transportHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("td", [
                                  _vm.isFieldRequired("storageHeight")
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.$t("material.storageHeight"))
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "storageHeight",
                                          rules: _vm.isFieldRequired(
                                            "storageHeight"
                                          )
                                            ? [_vm.rules.requiredRules]
                                            : [],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            oninput:
                                              "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                          },
                                          model: {
                                            value:
                                              _vm.createParams.storageHeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "storageHeight",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.storageHeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.oldRecordExists
                                  ? _c(
                                      "td",
                                      {
                                        style: {
                                          color:
                                            _vm.createParams.storageHeight ==
                                            _vm.oldParams.storageHeight
                                              ? ""
                                              : "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.oldParams.storageHeight
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.storageHeight ==
                                        _vm.contrastParams.storageHeight
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.contrastParams.storageHeight
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isPop
                            ? _c("tr", [
                                _c("th", { staticClass: "card-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("material.storageInformation")
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.weightUnit"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "weightUnit" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.createParams.weightUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "weightUnit",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "createParams.weightUnit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.weightUnit ==
                                        _vm.oldParams.weightUnit
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.weightUnit) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.weightUnit ==
                                    _vm.contrastParams.weightUnit
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.weightUnit) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("material.minimumDcReceivingValidity")
                                )
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "minimumDcReceivingValidity",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        oninput:
                                          "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                                      },
                                      model: {
                                        value:
                                          _vm.createParams
                                            .minimumDcReceivingValidity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "minimumDcReceivingValidity",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.minimumDcReceivingValidity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams
                                          .minimumDcReceivingValidity ==
                                        _vm.oldParams.minimumDcReceivingValidity
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldParams
                                            .minimumDcReceivingValidity
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams
                                      .minimumDcReceivingValidity ==
                                    _vm.contrastParams
                                      .minimumDcReceivingValidity
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contrastParams
                                        .minimumDcReceivingValidity
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("material.materialFactoryDetails")
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.isFresh"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isFresh" } },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                      },
                                      model: {
                                        value: _vm.createParams.isFresh,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "isFresh",
                                            $$v
                                          )
                                        },
                                        expression: "createParams.isFresh",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_MATERIAL_RECORD",
                                        field: "IS_NOT",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.oldParams.isFresh,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.oldParams,
                                            "isFresh",
                                            $$v
                                          )
                                        },
                                        expression: "oldParams.isFresh",
                                      },
                                    }),
                                    _vm.createParams.isFresh !=
                                      _vm.oldParams.isFresh &&
                                    _vm.oldParams.isFresh
                                      ? _c("span", [_vm._v("!")])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "IS_NOT",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.contrastParams.isFresh,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contrastParams,
                                        "isFresh",
                                        $$v
                                      )
                                    },
                                    expression: "contrastParams.isFresh",
                                  },
                                }),
                                _vm.createParams.isFresh !=
                                  _vm.contrastParams.isFresh &&
                                _vm.contrastParams.isFresh
                                  ? _c("span", [_vm._v("!")])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.originCountry"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "", clearable: "" },
                                      model: {
                                        value: _vm.createParams.originCountry,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.createParams,
                                            "originCountry",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "createParams.originCountry",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.originCountry ==
                                        _vm.oldParams.originCountry
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.originCountry) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.originCountry ==
                                    _vm.contrastParams.originCountry
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.originCountry) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("th", { staticClass: "card-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("material.affiliatedFactory"))
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("span", [_vm._v("*")]),
                              _vm._v(_vm._s(_vm.$t("material.tmPlantName"))),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "tmPlantName" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          content: _vm.createParams.tmPlantName,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            clearable: "",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.createParams.tmPlantName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.createParams,
                                                "tmPlantName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "createParams.tmPlantName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.oldRecordExists
                              ? _c(
                                  "td",
                                  {
                                    style: {
                                      color:
                                        _vm.createParams.tmPlantName ==
                                        _vm.oldParams.tmPlantName
                                          ? ""
                                          : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.oldParams.tmPlantName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                style: {
                                  color:
                                    _vm.createParams.tmPlantName ==
                                    _vm.contrastParams.tmPlantName
                                      ? ""
                                      : "red",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.contrastParams.tmPlantName) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm.showFreightInfo
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.$t("material.freightInfo") } },
                        [
                          _c(
                            "div",
                            [
                              _vm.canEditFreightInfo
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.addFreightRow },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.add")))]
                                  )
                                : _vm._e(),
                              _vm.canEditFreightInfo
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.delFreightRow },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.del")))]
                                  )
                                : _vm._e(),
                              _c(
                                "el-table",
                                {
                                  ref: "freightInfoTable",
                                  attrs: { data: _vm.createParams.freightInfo },
                                },
                                [
                                  _vm.canEditFreightInfo
                                    ? _c("el-table-column", {
                                        attrs: { type: "selection" },
                                      })
                                    : _vm._e(),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      sortable: "",
                                      prop: "dcName",
                                      label: "到货仓库（DC）",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("ic-select", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.canEditFreightInfo,
                                                  options: _vm.selectedDcs,
                                                },
                                                model: {
                                                  value: scope.row.tmDcId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "tmDcId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.tmDcId",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3699995194
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      sortable: "",
                                      prop: "pickupPoint",
                                      label: "提货点",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("ic-select", {
                                                attrs: {
                                                  filterable: true,
                                                  disabled:
                                                    !_vm.canEditFreightInfo,
                                                  table: "BASE",
                                                  field: "PICKUP_POINT",
                                                },
                                                model: {
                                                  value: scope.row.tmPickupId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "tmPickupId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.tmPickupId",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2609214166
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      sortable: "",
                                      prop: "transportaionMethod",
                                      label: "运输方式",
                                      width: "140",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("ic-select", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.canEditFreightInfo,
                                                  table: "COMMON",
                                                  field: "TRANSPORTAION_METHOD",
                                                },
                                                model: {
                                                  value:
                                                    scope.row
                                                      .transportaionMethod,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "transportaionMethod",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.transportaionMethod",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3364382588
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "freshPreparationTime",
                                      label: "鲜货准备时间",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled:
                                                    !_vm.canEditFreightInfo,
                                                  type: "number",
                                                },
                                                model: {
                                                  value:
                                                    scope.row
                                                      .freshPreparationTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "freshPreparationTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.freshPreparationTime",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4065208403
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "inboundTransferTime",
                                      label: "Inbound物流运输时间",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled:
                                                    !_vm.canEditFreightInfo,
                                                  type: "number",
                                                },
                                                model: {
                                                  value:
                                                    scope.row
                                                      .inboundTransferTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "inboundTransferTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.inboundTransferTime",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      16864830
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "freight",
                                      label: "产品运费（不含税）",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                },
                                                model: {
                                                  value: scope.row.freight,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "freight",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.freight",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2891479456
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "effectiveBeginDate",
                                      label: "价格有效起始日期",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.createParams.isNewDc === "Y"
                                                ? _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      type: "date",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .effectiveBeginDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "effectiveBeginDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.effectiveBeginDate",
                                                    },
                                                  })
                                                : _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateFormatFilter"
                                                        )(
                                                          scope.row
                                                            .effectiveBeginDate,
                                                          "YYYY-MM-DD"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      997281109
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "spTime",
                                      label: "运费状态",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("ic")(
                                                      scope.row.feightStatus,
                                                      "COMMON",
                                                      "STATUS"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3184629106
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: _vm.$t("common.approvalLog") } },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.workFlowLogList,
                            stripe: "",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "createDate",
                              label: _vm.$t("common.OperationTime"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormatFilter")(
                                            scope.row.createDate,
                                            "YYYY-MM-DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "operatorName",
                              label: _vm.$t("common.OperatorName"),
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action",
                              label: _vm.$t("common.PedagogicalOperation"),
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "comments",
                              label: _vm.$t("common.opinion"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.isConversionCoefficient"),
            visible: _vm.showConversionCoefficient,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showConversionCoefficient = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "form_border", attrs: { "label-width": "110px" } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("material.conversionCoefficient"),
                            required: "",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              clearable: "",
                              table: "TM_MATERIAL_RECORD",
                              field: "CONVERSION_COEFFICIENT",
                              disabled: _vm.isSup,
                            },
                            model: {
                              value: _vm.createParams.conversionCoefficient,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.createParams,
                                  "conversionCoefficient",
                                  $$v
                                )
                              },
                              expression: "createParams.conversionCoefficient",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveConversion()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showConversionCoefficient = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.showApproval,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showApproval = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "info",
              staticClass: "form_border",
              attrs: {
                model: _vm.info,
                "label-position": _vm.labelPosition,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.auditor"),
                            placeholder: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.username,
                              callback: function ($$v) {
                                _vm.username = $$v
                              },
                              expression: "username",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalTime"),
                            placeholder: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalResults"),
                            placeholder: "",
                            prop: "approvalType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.info.approvalType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.info, "approvalType", $$v)
                                },
                                expression: "info.approvalType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.pass")))]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "2" },
                              model: {
                                value: _vm.info.approvalType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.info, "approvalType", $$v)
                                },
                                expression: "info.approvalType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.noPass")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalRemarks"),
                            placeholder: "",
                            prop: "approvalDescription",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.info.approvalDescription,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "approvalDescription", $$v)
                              },
                              expression: "info.approvalDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save(3)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showApproval = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.showContrast"),
            visible: _vm.showContrast,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showContrast = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "form_border",
              attrs: {
                model: _vm.queryCondition,
                "label-position": _vm.labelPosition,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Category1",
                            prop: "categoryLevel1Id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              on: {
                                change: function ($event) {
                                  return _vm.changeCategory1Contrast()
                                },
                              },
                              model: {
                                value: _vm.queryCondition.categoryLevel1Id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "categoryLevel1Id",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.categoryLevel1Id",
                              },
                            },
                            _vm._l(_vm.categoryList1, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.tmCategoryId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Category2",
                            prop: "categoryLevel2Id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              on: {
                                change: function ($event) {
                                  return _vm.changeCategory2Contrast()
                                },
                              },
                              model: {
                                value: _vm.queryCondition.categoryLevel2Id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "categoryLevel2Id",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.categoryLevel2Id",
                              },
                            },
                            _vm._l(
                              _vm.categoryList2Contrast,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.tmCategoryId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Category3",
                            prop: "categoryLevel3Id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.categoryLevel3Id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "categoryLevel3Id",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.categoryLevel3Id",
                              },
                            },
                            _vm._l(
                              _vm.categoryList3Contrast,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.tmCategoryId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("material.eightBitCode"),
                            prop: "eightBitCode",
                            "label-width": "110px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.eightBitCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "eightBitCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryCondition.eightBitCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("material.eightBitCodeName"),
                            prop: "eightBitCodeName",
                            "label-width": "110px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.eightBitCodeName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "eightBitCodeName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryCondition.eightBitCodeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.restQueryForm("queryCondition")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { "padding-top": "15px" } }),
          _c(
            "el-table",
            {
              ref: "tableData",
              staticClass: "table",
              attrs: {
                sortable: "",
                "max-height": "435",
                data: _vm.tableData,
                "row-key": "tmMaterialId",
                stripe: "",
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "56",
                  label: _vm.$t("common.select"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.tmMaterialId },
                            model: {
                              value: _vm.radioVal,
                              callback: function ($$v) {
                                _vm.radioVal = $$v
                              },
                              expression: "radioVal",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eightBitCode",
                  label: _vm.$t("material.eightBitCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eightBitCodeName",
                  label: _vm.$t("material.eightBitCodeName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: _vm.$t("material.supplier"),
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmContrast },
                },
                [_vm._v(_vm._s(_vm.$t("material.determine")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showContrast = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("material.listOfAttachments"),
            visible: _vm.showFileTable,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFileTable = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.fileList,
                stripe: "",
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "documentName",
                  label: _vm.$t("common.file"),
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.documentName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "tmDocumentId", "min-width": "130px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.deleteFile(
                                  scope.row.tmDocumentId,
                                  scope.$index,
                                  _vm.fileList
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.del")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("settlement-unit-dialog", {
        attrs: {
          "is-show": _vm.showSettlementUnitDialog,
          "create-fun": _vm.onConfirmSettlementUnit,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showSettlementUnitDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showSettlementUnitDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showSettlementUnitDialog = false
          },
        },
      }),
      _c("planDialog", {
        attrs: {
          "is-show": _vm.showPlanDialog,
          scoped: true,
          "create-fun": _vm.onConfirmPlan,
          "parent-id": _vm.parentId,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showPlanDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showPlanDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showPlanDialog = false
          },
        },
      }),
      _c("gri-dialog", {
        ref: "Grichild",
        attrs: {
          "is-show": _vm.showGriDialog,
          "create-fun": _vm.onConfirmGri,
          materialType: _vm.materialType,
          "is-conventional-materials": _vm.isConventionalMaterials,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showGriDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showGriDialog = $event
          },
          "update:isConventionalMaterials": function ($event) {
            _vm.isConventionalMaterials = $event
          },
          "update:is-conventional-materials": function ($event) {
            _vm.isConventionalMaterials = $event
          },
          hideDialog: function ($event) {
            _vm.showGriDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }